<template>
  <div class="form-container">
    <div>
      <div>
		<span style="font-size: 1.5rem;font-weight: 700;">
        日付検索
        </span>
      </div>
    </div>
     <div style="width: 100%;display: flex; flex-direction: row; justify-content:left; align-items: center;gap:20px">
      <div>期間</div>
      <input type="date" style="height:20px" name="date_begin" ref="dateBeginInput" v-model="searchForm.date_begin" maxlength="10">
      <!--input style="height: 38px; border-radius: 4px;" type="date" name="date_begin" ref="dateBeginInput" v-model="searchForm.date_begin" maxlength="10"^-->
      <div>～</div>
      <input type="date" style="height:20px;" name="date_end" ref="dateEndInput" v-model="searchForm.date_end" maxlength="10">
      <!--input style="height: 38px; border-radius: 4px;" type="date" name="date_end" ref="dateEndInput" v-model="searchForm.date_end" maxlength="10"-->
      <button @click="search" class="search-button">検索</button>
     </div>
      
    <h1>獣害対策（地図）</h1>
  <!--<button @click="triggerTest">検証</button>-->
    <div class="wildlife-damage-map">
      <div id="map"></div>
      <!-- <div id="legend" class="legend"></div> -->
    </div>
  </div>
</template>

<script>
import * as wildlifeDamageMapApi from '@/api/wildlifeDamageMapApi';
import axios from 'axios';

import "@/assets/styles/WildLifeDamageMap.css";
import "@/assets/styles/Common.css";

//獣種アイコンをimport
import WildBoarIcon from '@/assets/icons/wildboar.png';
import DeerIcon from '@/assets/icons/deer.png';
import DearIcon from '@/assets/icons/bear.png';
import MonkeyIcon from '@/assets/icons/monkey.png';
import RaccoonDogIcon from '@/assets/icons/raccoondog.png';
import BadgerIcon from '@/assets/icons/badger.png';
import CivetIcon from '@/assets/icons/civet.png';
import RaccoonIcon from '@/assets/icons/raccoon.png';
import NutriaIcon from '@/assets/icons/nutria.png';
import BirdIcon from '@/assets/icons/bird.png';
import OtherIcon from '@/assets/icons/other.png';
import UnknownIcon from '@/assets/icons/unknown.png';

//データ種別アイコンをimport
import DamageIcon from '@/assets/icons/damage.png';
import CaptureIcon from '@/assets/icons/capture.png';
import SightingIcon from '@/assets/icons/sighting.png';
import TracesIcon from '@/assets/icons/traces.png';
import TrapIcon from '@/assets/icons/trap.png';
import UnknownAndOtherIcon from '@/assets/icons/unknownandother.png';

//MeshLabelOverlayをimport
import { createMeshLabelOverlay }  from "@/libs/MeshLabelOverlay";
import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { toRaw } from "vue";
import { markRaw } from "vue";

export default {
  name: "WildlifeDamageMap",
  data() {
    return {
      isEditing: false, // 現在編集モードかどうかを管理
      isFenceEditPopupOpen: false, // 子画面が表示されているかどうかを管理
      isDisplaySettingsPopupOpen: false, // 表示設定ポップアップの状態管理
      isLayoutSettingsPopupOpen: false,
      addingMarkers: false,
      currentPolylinePath: [],
      fenceType: "電気", // 初期の柵種を電気に設定
      fenceColors: {
        type1:"#FF0000", //初期カラーの赤
        電気: "#FF1493", // 深いピンク
        金属: "#9400D3", // ダークバイオレット
        ネット: "#0000FF", // 青
        ワイヤーメッシュ: "#FFFF00", // 黄色
        その他: "#864A2B", // 茶色
      },
      markers: [], // ピンを保存するための配列
      currentCategory: 'all', // 初期表示のカテゴリ
      displayData: {
        animal: {
          // すべて: true,
          イノシシ: true,
          ニホンジカ: true,
          クマ: true,
          サル: true,
          タヌキ: true,
          アナグマ: true,
          ハクビシン: true,
          アライグマ: true,
          ヌートリア: true,
          鳥類: true,
          その他: true,
          不明: true,
        },
        type: {
          // すべて: true,
          被害: true,
          捕獲: true,
          目撃: true,
          痕跡: true,
          わな: true,
          その他: true,
        },
        fence: {
          // すべて: true,
          電気: true,
          金属: true,
          ネット: true,
          ワイヤーメッシュ: true,
          その他: true,
        },
        heatMap: {
          被害金額: false,
          生息領域: false,
        },
      },
      animalIcons: {
        イノシシ: WildBoarIcon,
        ニホンジカ: DeerIcon,
        クマ: DearIcon,
        サル: MonkeyIcon,
        タヌキ: RaccoonDogIcon,
        アナグマ: BadgerIcon,
        ハクビシン: CivetIcon,
        アライグマ: RaccoonIcon,
        ヌートリア: NutriaIcon,
        鳥類: BirdIcon,
        その他: OtherIcon,
        不明: UnknownIcon,
      },
      typeIcons: {
        被害: DamageIcon,
        捕獲: CaptureIcon,
        目撃: SightingIcon,
        痕跡: TracesIcon,
        わな: TrapIcon,
        その他: UnknownAndOtherIcon,
      },
      typeColors: {
        被害: '#fce4d6', // 赤
        捕獲: '#c6e0b4', // 緑
        目撃: '#ffe699', // オレンジ
        痕跡: '#bdd7ee', // 水色
        わな: '#ffccff', // ピンク
        その他: '#d9d9d9', // グレー
      },
      heatMapColors: {
        被害金額: "#ff33cc",
        生息領域: "#0099ff",
      },
      tempDisplayData: {
        animal: {
          // すべて: false,
          イノシシ: false,
          ニホンジカ: false,
          クマ: false,
          サル: false,
          タヌキ: false,
          アナグマ: false,
          ハクビシン: false,
          アライグマ: false,
          ヌートリア: false,
          鳥類: false,
          その他: false,
          不明: false,
        },
        type: {
          // すべて: false,
          被害: false,
          捕獲: false,
          目撃: false,
          痕跡: false,
          わな: false,
          その他: false,
        },
        fence: {
          // すべて: false,
          電気: false,
          金属: false,
          ネット: false,
          ワイヤーメッシュ: false,
          その他: false,
        },
      // legendData: {
      //   animal: [
      //     'イノシシ',
      //     'ニホンジカ',
      //     'クマ',
      //     'サル',
      //     'タヌキ',
      //     'アナグマ',
      //     'ハクビシン',
      //     'アライグマ',
      //     'ヌートリア',
      //     '鳥類',
      //     'その他',
      //     '不明',
      //   ],
      //   type: ['被害', '捕獲', '目撃', '痕跡', 'わな', 'その他'],
      //   fence: ['電気', '金属', 'ネット', 'ワイヤーメッシュ', 'その他'],
        heatMap: {
          被害金額: false,
          生息領域: false,
        },
      },
      searchForm: {
        date_begin: '',
        date_end: ''
      },
      habitatAreaHeatmapLayer: null,
      damageAmountHeatmapLayer: null,
      layoutData: {
        background: {
          '地図': 'roadmap',
          '地形図': 'terrain',
          '航空写真': 'satellite'
        },
        layout: [
          'ラベル表示',
          'メッシュ表示',
          '鳥獣保護区',
        ],
      },
      currentSelectBackground: '地図',
      currentSelectLayout: ['ラベル表示'],
      labelLayoutSet: true,
      meshLayoutSet: false,
      wildlifeSanctuaryLayoutSet: false,
      fetchGeoJSON: false,
      meshRects: [],
      meshLabels: [],
      meshListener: null,
      popupControlRoot: null,
      popupDetailControlRoot: null,
      map: null, // マップのインスタンスを保持するためのプロパティ
      wildlifeMarkersData: [], // 新しいマーカーを保存するための配列
      wildlifeMarkersView: [], // 新しいマーカーを保存するための配列
      wildlifeMarkerClusterer: null,
      polylines: [], // 登録されているすべての柵情報（ポリライン）
      wildlifeData: [
        { id: 1, lat: 35.6865, lng: 139.7064, animalType: 'イノシシ', incidentType: '被害' },
        { id: 2, lat: 35.6852, lng: 139.7110, animalType: 'ニホンジカ', incidentType: '捕獲' },
        { id: 3, lat: 35.6852, lng: 139.7110, animalType: 'クマ', incidentType: '被害' },
        { id: 4, lat: 35.6845, lng: 139.7090, animalType: 'サル', incidentType: '目撃' },
        { id: 5, lat: 35.6840, lng: 139.7080, animalType: 'タヌキ', incidentType: '痕跡' },
        { id: 6, lat: 35.6860, lng: 139.7090, animalType: 'アナグマ', incidentType: 'わな' },
        { id: 7, lat: 35.6835, lng: 139.7090, animalType: 'ハクビシン', incidentType: '被害' },
        { id: 8, lat: 35.6869, lng: 139.7090, animalType: 'アライグマ', incidentType: '捕獲' },
        { id: 9, lat: 35.6874, lng: 139.7105, animalType: 'ヌートリア', incidentType: '目撃' },
        { id: 10, lat: 35.6845, lng: 139.7115, animalType: '鳥類', incidentType: '痕跡' },
        { id: 11, lat: 35.6830, lng: 139.7120, animalType: 'その他', incidentType: 'わな' },
        { id: 12, lat: 35.6845, lng: 139.7125, animalType: '不明', incidentType: '被害' },
      ],
      defaultFenceData: [
        {
          id: 1,
          type: "電気",
          path: [
            { lat: 35.68682607707368, lng: 139.70455498145836 },
            { lat: 35.68910915178453, lng: 139.71107811378258 },
            { lat: 35.68637293997047, lng: 139.71444696830528 },
          ],
          details: {
            name: "電気柵A",
            length: "1.5",
            installDate: "2023-01-01",
            removeDate: "",
            additionalNotes: "高電圧注意",
          },
        },
        {
          id: 2,
          type: "金属",
          path: [
            { lat: 35.68424664688105, lng: 139.70567078040855 },
            { lat: 35.68605922816046, lng: 139.71215099738853 },
            { lat: 35.68485665479378, lng: 139.7141251032235 },
          ],
          details: {
            name: "金属柵B",
            length: "2.0",
            installDate: "2023-02-01",
            removeDate: "2023-10-01",
            additionalNotes: "耐久性が高い",
          },
        },
      ],
      selectMesh: '0',
      rects:[],
      labels:[],
      pinkGradient: [
      "rgba(255, 51, 204, 0)",
      "rgba(255, 180, 230, 0.4)",
      "rgba(255, 130, 215, 0.6)",
      "rgba(255, 90, 205, 0.7)",
      "rgba(255, 51, 204, 0.8)",
      "rgba(220, 30, 180, 0.9)",
      "rgba(180, 0, 150, 1)",
      "rgba(130, 0, 110, 1)"
    ],

    skyBlueGradient: [
      "rgba(0, 153, 255, 0)",
      "rgba(180, 220, 255, 0.4)",
      "rgba(130, 200, 255, 0.6)",
      "rgba(80, 180, 255, 0.7)",
      "rgba(0, 153, 255, 0.8)",
      "rgba(0, 130, 220, 0.9)",
      "rgba(0, 100, 180, 1)",
      "rgba(0, 70, 140, 1)"
    ],
      formattedWildlifeData : null,
      formattedFenceData : null,
      markerloaded: false,
      markerloadedCount: 0,
      markerloadedTotalCount: 0,
      currentRequestId: 0,
    };
  },
  mounted() {
    this.loadGoogleMapsScript();// Google Maps API読み込み
    this.tempDisplayData = JSON.parse(JSON.stringify(this.displayData)); // 深いコピーを使用
    const storageKey = "displaySettings";
    const storedData = localStorage.getItem(storageKey);

    if (storedData) {
      try {
        this.displayData = JSON.parse(storedData);
        //console.log("ローカルストレージから表示設定を復元しました:", this.displayData);
      } catch (error) {
        console.error("表示設定の復元に失敗しました:", error);
      }
    }
  },
  created() {
    this.searchForm.date_begin = this.fiscalStartDate;
    this.searchForm.date_end = this.getToday;
  },
  computed: {
    fiscalStartDate() {
      const today = new Date();
      const year = today.getFullYear();
      const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const march31 = new Date(year, 2, 31);
      const result = todayDateOnly <= march31 ? new Date(year - 1, 3, 1) : new Date(year, 3, 1);
      return this.formatDate(result);
    },
    getToday() {
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
  },
  methods: {

    search() {

      // -----------------------------------------
      // 入力要素（date input）の取得
      // -----------------------------------------
      const beginInput = this.$refs.dateBeginInput;
      const endInput = this.$refs.dateEndInput;

      // -----------------------------------------
      // ブラウザの標準バリデーションチェック
      // ・未完成入力（年のみ等）
      // ・存在しない日付（例：2026-04-31）
      // ・フォーマット不正
      // 上記は checkValidity() で検出する
      // -----------------------------------------
      if (!beginInput.checkValidity()) {
        alert("開始日付は正しい日付を入力してください");
        return;
      }
    
      if (!endInput.checkValidity()) {
        alert("終了日付は正しい日付を入力してください");
        return;
      }

      // -----------------------------------------
      // YYYY-MM-DD 形式（4桁年）を厳密チェック
      // ※ HTML5では5桁以上の年も許容されるため
      // 業務仕様として4桁固定にする
      // -----------------------------------------
      const strictDateRe = /^\d{4}-\d{2}-\d{2}$/;

      if (this.searchForm.date_begin && !strictDateRe.test(this.searchForm.date_begin)) {
        alert("開始日付は不正です（YYYY/MM/DDフォーマットで入力してください）");
        return;
      }
      if (this.searchForm.date_end && !strictDateRe.test(this.searchForm.date_end)) {
        alert("終了日付は不正です（YYYY/MM/DDフォーマットで入力してください）");
        return;
      }

      // -----------------------------------------
      // 期間の前後関係チェック
      // 開始日 <= 終了日 であること
      // -----------------------------------------
      if (this.searchForm.date_begin && 
          this.searchForm.date_end && 
          this.searchForm.date_begin > this.searchForm.date_end) {
        alert("終了日付より前の開始日付を入力してください");
        return;
      }

      // -----------------------------------------
      // 検索実行
      // -----------------------------------------
      this.updateWildlifeAndFenceDisplay();
    },

    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    // 位置情報をランダムに少しだけずらす関数（検証用）
    adjustPath(path) {
        const offset = 0.0001; // ずらす範囲
        return path.map((point) => ({
            lat: point.lat + (Math.random() * offset - offset / 2),
            lng: point.lng + (Math.random() * offset - offset / 2),
        }));
    },
    //検証用の関数
    async triggerTest() {
      try {
        // `fetchAndFormatWildlifeData` を呼び出して結果を取得
        const wildlifeData = await this.fetchAndFormatWildlifeData();

        alert("鳥獣被害データの取得が完了しました");
      } catch (error) {
        console.error("鳥獣被害データの取得中にエラーが発生しました:", error);
        alert("鳥獣被害データの取得に失敗しました");
      }
    },

    // JSON形式を確認するユーティリティ関数
    isValidJSON(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch {
        return false;
      }
    },



    

    /*マップ関連*/
    // Google Mapsスクリプトの読み込み
    loadGoogleMapsScript() {
      if (!window.google) {
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
         //script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBhQdCQni4u93ac-ILc5ksjaTmckPU3Odg&callback=initMap`;
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBjnCwrVTh_kr-6rGnwU6oYK8Mu7s_ZAwQ&callback=initMap&libraries=visualization,marker&v=3.64`;
        window.initMap = () => this.initMap();
        document.head.appendChild(script);
      } else {
        this.initMap();
      }
    },
    // マップの初期化
    async initMap() {
      if (!window.google || !google.maps) {
        console.error("Google Mapsが読み込まれていません");
        return;
      }
      // 現在位置を取得
      const getCurrentPosition = () => {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject("Geolocation APIがサポートされていません");
          } else {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                resolve({
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                });
              },
              (error) => {
                console.warn("現在位置の取得に失敗しました", error);
                // デフォルト値（新宿御苑前）を使用
                resolve({ lat: 35.6852, lng: 139.71 });
              }
            );
          }
        });
      };
      // 現在位置を取得してマップを初期化
      const center = await getCurrentPosition();
      this.map = new google.maps.Map(document.getElementById("map"), { // インスタンスを保存
        zoom: 16.0,
        center: center, // 現在位置を中心に設定
        // mapTypeControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: true,
        scaleControl: true,
        rotateControl: true,
        mapTypeId: "roadmap",
        clickableIcons: false,
        disableDoubleClickZoom: true,
      });
      // マップ上にポップアップを配置するためのルート要素を生成
      this.popupControlRoot = document.createElement("div");
      // マップ用ポップアップの共通スタイルクラスを付与
      this.popupControlRoot.classList.add("map-popup-root");
      // 作成した要素をGoogleマップの左中央コントロール領域に追加
      // （地図UIレイヤー上に固定表示するため）
      this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push(this.popupControlRoot);
      this.wildlifeLayer = new google.maps.Data();
      this.wildlifeLayer.setStyle({
        fillColor: '#EE82EE',
        strokeWeight: 3,
        strokeColor: '#BA55D3',
        fillOpacity: 0.3,
      });
      //console.log("Google Mapsが初期化されました");
      // // 地図描画が完了した後に凡例を生成
      // google.maps.event.addListenerOnce(this.map, "idle", () => {
      //     this.createLegend(); // 地図描画が完了した後に凡例を生成
      //     const legendControl = document.getElementById('legend');
      //     if (legendControl) {
      //         this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendControl);
      //     }
      // });
      this.wildlifeMarkerClusterer = new MarkerClusterer({
        map: this.map,
        markers: [],
        algorithm: new SuperClusterAlgorithm({
          radius: 90, 
          maxZoom: 20,
          minPoints: 3,
          nodeSize: 32,
        }),
        onClusterClick:(cluster) => {
          const bounds = this.map.getBounds();
          const center = bounds.getCenter();
          this.map.setCenter(center);
          this.map.setZoom(this.map.getZoom() + 1);
        },
      });
      await this.initializeFencePolylines(this.map);
      this.initializeMapControlButtons(this.map);
      this.setupMapClick(this.map);
      await this.updateWildlifeAndFenceDisplay();
      this.initPopupDetailControlRoot();
      this.map.addListener('idle', () => {
        setTimeout(() => {
          this.drawMesh();
        }, 500);
      });
    },
    initPopupDetailControlRoot() {
      const mapDiv = document.getElementById("map");
      const gmStyle = mapDiv.querySelector('.gm-style');
      if (gmStyle) {
        let popupContainer = gmStyle.querySelector('.map-popup-root-relative');
        if (!popupContainer) {
          this.popupDetailControlRoot = document.createElement("div");
          this.popupDetailControlRoot.classList.add("map-popup-root-relative");
          gmStyle.appendChild(this.popupDetailControlRoot);
        }
      }
    },
    //マップの再生成
    async resetMap() {
      this.fetchGeoJSON = false;
      this.isDisplaySettingsPopupOpen = false;
      this.isLayoutSettingsPopupOpen = false;
      // console.log("resetMap: 開始");
      if (this.map) {
        // 現在の地図の縮尺と中心を取得
        var currentZoom = this.map.getZoom();
        const currentCenter = this.map.getCenter();

        // 現在のポリラインやマーカーをすべて削除
        this.polylines.forEach((polyline) => toRaw(polyline).setMap(null));
        this.polylines = [];
        this.map = null;

        // 地図を再初期化
        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: currentZoom, // 縮尺を引き継ぎ
          center: currentCenter, // 中心座標を引き継ぎ
          // mapTypeControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
          scaleControl: true,
          rotateControl: true,
          mapTypeId: "roadmap",
          clickableIcons: false,
          disableDoubleClickZoom: true,
        });
        this.wildlifeLayer = new google.maps.Data();
        this.wildlifeLayer.setStyle({
          fillColor: '#EE82EE',
          strokeWeight: 3,
          strokeColor: '#BA55D3',
          fillOpacity: 0.3,
        });
        // マップ上にポップアップを配置するためのルート要素を生成
        this.popupControlRoot = document.createElement("div");
        // マップ用ポップアップの共通スタイルクラスを付与
        this.popupControlRoot.classList.add("map-popup-root");
        // 作成した要素をGoogleマップの左中央コントロール領域に追加
        // （地図UIレイヤー上に固定表示するため）
        this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push(this.popupControlRoot);
        this.backgroundLayoutSettings();
        await this.layoutSettings(); 
        // 再初期化後の処理を実行
        await this.initializeFencePolylines(this.map); // ポリラインを再描画
        this.initializeMapControlButtons(this.map); // ボタンを再配置
        this.setupMapClick(this.map); // クリックイベントを再設定
        this.wildlifeMarkerClusterer = new MarkerClusterer({
          map: this.map,
          markers: [],
          algorithm: new SuperClusterAlgorithm({
            radius: 90, 
            maxZoom: 20,
            minPoints: 3,
            nodeSize: 32,
          }),
          onClusterClick:(cluster) => {
            const bounds = this.map.getBounds();
            const center = bounds.getCenter();
            this.map.setCenter(center);
            this.map.setZoom(this.map.getZoom() + 1);
          },
        });
        await this.updateWildlifeAndFenceDisplay(); // 表示データを更新
        this.initPopupDetailControlRoot();
        this.map.addListener('idle', () => {
          setTimeout(() => {
            this.drawMesh();
          }, 500);
        });
        await new Promise((resolve) => {
          google.maps.event.addListenerOnce(this.map, "idle", resolve);
        });
        // // 凡例の再生成
        // google.maps.event.addListenerOnce(this.map, "idle", () => {
        //     this.createLegend(); // 地図描画が完了した後に凡例を生成
        //     const legendControl = document.getElementById('legend');
        //     if (legendControl) {
        //         this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendControl);
        //     }
        // });
      }
    },
    // ポリラインの初期設定
    async initializeFencePolylines(map) {
      try {
        const existingPolylinesPaths = await this.fetchAndFormatFenceData(); // 非同期でデータを取得

        let polylines = [];

        existingPolylinesPaths.forEach((fenceData, index) => {
          const isFenceVisible = this.displayData.fence[fenceData.type];
          if (Array.isArray(fenceData.path) && fenceData.path.length > 0 && isFenceVisible) {
            const polyline = new google.maps.Polyline({
              path: fenceData.path,
              strokeColor: this.fenceColors[fenceData.type] || "#000000",
              strokeOpacity: 1.0,
              strokeWeight: 3,
              optimized: false, // 最適化を無効化
            });

            polyline.setMap(map);

            // ポリラインの詳細情報を設定
            polyline.fenceDetails = this.createFenceDetails(fenceData, index);

            // ダブルクリックイベントを設定
            google.maps.event.clearInstanceListeners(polyline);
            polyline.addListener("dblclick", async () => {
              await this.showFencePopup("edit", polyline.fenceDetails.id); // IDを渡す
            });

            polylines.push(polyline);
          } else {
            console.warn("Invalid fence data skipped:", fenceData);
          }
        });

        this.polylines = polylines;
      } catch (error) {
        console.error("ポリラインの初期化中にエラーが発生しました:", error);
      }
    },
    // マップのコントロールボタン(編集開始・表示設定)初期化
    initializeMapControlButtons(map) {
      // 状態変数を初期化
      let isEditing = false;

      // ボタン生成関数
      const createButton = (text, callback, additionalClass = "") => {
        const buttonDiv = document.createElement("div");
        buttonDiv.classList.add("button-style"); // 基本スタイルのクラスを追加
        if (additionalClass) {
          buttonDiv.classList.add(additionalClass); // 追加クラスを指定
        }
        buttonDiv.innerHTML = `<div class="custom-control-text">${text}</div>`;
        
        buttonDiv.addEventListener("click", () => {
          if (!this.isFenceEditPopupOpen || additionalClass === "display-settings-button") {
            // 表示設定ボタンは無効化の影響を受けない
            callback();
          }
        });

        return buttonDiv;
      };

      // 編集開始/終了ボタン
      const toggleButtonDiv = createButton("編集開始", () => {
		// 2026/06/12 RFJ R.Komatsu
        const section = localStorage.getItem("section");
		if (section=='9999') return;
        if (isEditing) {
          // 編集終了処理

          if (this.markers.length < 2) { // マーカーが2つ未満の場合
            alert("マーカーは2つ以上必要です");
            return; // 処理をキャンセル
          }

          // 全画面モードを解除
          if (document.fullscreenElement) {
            document.exitFullscreen()
              .then(() => {
                console.log("全画面モードが解除されました");
              })
              .catch((err) => {
                console.error("全画面モードの解除に失敗しました:", err);
              });
          }

          isEditing = false;
          toggleButtonDiv.innerHTML = `<div class="custom-control-text">編集開始</div>`;
          toggleButtonDiv.classList.remove("end-button");
          toggleButtonDiv.classList.add("start-button");

          this.addingMarkers = false;

          // 編集終了時の処理
          if (this.polylines.length > 0) {
            this.polylines[this.polylines.length - 1].setPath(this.currentPolylinePath);
          }
          this.removeMarkers();
          this.showFencePopup("new");
        } else {
          // 編集開始処理
          isEditing = true;
          toggleButtonDiv.innerHTML = `<div class="custom-control-text">編集終了</div>`;
          toggleButtonDiv.classList.remove("start-button");
          toggleButtonDiv.classList.add("end-button");

          this.addingMarkers = true;

          const newPolyline = new google.maps.Polyline({
            path: [],
            strokeColor: this.fenceColors[this.fenceType],
            strokeOpacity: 1.0,
            strokeWeight: 3,
          });
          newPolyline.setMap(map);
          this.polylines.push(newPolyline);
          this.currentPolylinePath = [];
          newPolyline.addListener("dblclick", () => {
            this.showFencePopup("new");
          });
        }
      }, "toggle-button");

      // 表示設定ボタン
      const displaySettingsButtonDiv = createButton("表示設定", () => {
        this.showDisplaySettingsPopup();
      }, "display-settings-button"); // 追加クラスを指定

      // レイヤー設定ボタン
      const layoutSettingsButtonDiv = createButton("レイヤー設定", () => {
        this.showLayoutSettingsPopup();
      }, "layout-settings-button");

      // 無効化状態を監視して更新
      const updateButtonState = () => {
        if (this.isFenceEditPopupOpen) {
          toggleButtonDiv.classList.add("disabled");
          displaySettingsButtonDiv.classList.add("disabled"); // 表示設定ボタン無効化
          layoutSettingsButtonDiv.classList.add("disabled"); // レイヤー設定ボタン無効化
          // 表示設定子画面を閉じる処理
          const settingsPopup = document.querySelector(".new-settings-popup");
          // レイヤー設定子画面を閉じる処理
          const layoutSettingsPopup = document.querySelector(".layout-settings-popup");
          if (settingsPopup) {
            settingsPopup.remove(); // 子画面を閉じる
            this.isDisplaySettingsPopupOpen = false; // フラグをリセット
          }
          if (layoutSettingsPopup) { 
            layoutSettingsPopup.remove();
            this.isLayoutSettingsPopupOpen = false;
          }

        } else {
          toggleButtonDiv.classList.remove("disabled");
          displaySettingsButtonDiv.classList.remove("disabled"); // 表示設定ボタン有効化
          layoutSettingsButtonDiv.classList.remove("disabled"); // レイヤー設定ボタン有効化
        }
      };

      // Vue のリアクティブデータの変化に基づいて無効化状態を更新
       this.$watch("isFenceEditPopupOpen", updateButtonState);

      // カスタムコントロール設定（地域メッシュ選択）
      const meshControlDiv = document.createElement('div');
      this.createMeshButton(meshControlDiv);
      meshControlDiv.index = 1;
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(meshControlDiv);

      // Google Maps コントロールに追加
      const controlDiv = document.createElement("div");
      controlDiv.appendChild(toggleButtonDiv); // トグルボタン
      controlDiv.appendChild(displaySettingsButtonDiv); // 表示設定ボタン
      controlDiv.appendChild(layoutSettingsButtonDiv); // レイヤー設定ボタン
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);

      // 初期スタイルを適用
      toggleButtonDiv.classList.add("start-button"); // 明示的に適用
      updateButtonState();

      // // マップの初期化完了後に凡例を作成
      // google.maps.event.addListenerOnce(map, 'idle', () => {
      //   this.createLegend();
      // });
    },
    
    // マップクリックイベント設定
    setupMapClick(map) {
      map.addListener("click", (event) => {
        if (this.addingMarkers) {
          this.addMarker(event.latLng, map);
        }
      });
    },

    // マーカーの追加
    addMarker(location, map) {
      const marker = new google.maps.Marker({
        position: location,
        map: map,
      });
      this.markers.push(marker);
      this.currentPolylinePath.push(location);
    },

    // マーカー削除
    removeMarkers() {
      this.markers.forEach(marker => {
        marker.setMap(null); // マップから削除
        marker.setVisible(false); // 見た目も確実に非表示にする
      });
      this.markers = []; // 配列をクリア
    },

    //ポリライン削除
    async removePolyline(polylineId) {
      const polyline = this.polylines[polylineId];
      if (polyline) {
        polyline.setMap(null); // 地図から削除
        this.polylines.splice(polylineId, 1); // 配列から削除
        // 地図全体をリセット
        await this.resetMap();
      }
    },
    
    // //凡例表示
    // createLegend() {
    //   let legend = document.getElementById('legend');
    //   if (!legend) {
    //       legend = document.createElement('div');
    //       legend.id = 'legend';
    //       legend.className = 'legend';

    //       // 地図コンテナに凡例を追加
    //       const mapContainer = document.getElementById('map');
    //       if (mapContainer) {
    //           mapContainer.appendChild(legend);
    //       }
    //   }

    //   // 凡例のスタイルを設定
    //   legend.innerHTML = ''; // 凡例をクリア
    //   legend.style.position = 'absolute'; // 地図コンテナ内で固定
    //   legend.style.bottom = '10px'; // 下から10px
    //   legend.style.left = '10px'; // 左から10px
    //   legend.style.backgroundColor = 'white'; // 背景色
    //   legend.style.padding = '10px'; // 内側余白
    //   legend.style.border = '1px solid #999'; // 枠線
    //   legend.style.borderRadius = '5px'; // 角の丸み
    //   legend.style.maxHeight = '620px'; // 最大高さ
    //   legend.style.overflowY = 'auto'; // 縦スクロールを有効化
    //   legend.style.zIndex = '1000'; // 前面に表示
    //   legend.style.fontSize = '14px'; // テキストサイズを固定
    //   legend.style.transform = 'none'; // 地図のスケーリングを防ぐ

    //   const createLegendSection = (title, items, iconGetter, colorGetter) => {
    //       const section = document.createElement('div');
    //       const japaneseTitle = {
    //           animal: '獣種',
    //           type: '種別',
    //           fence: '柵種',
    //       }[title] || title;
    //       section.innerHTML = `<h3>${japaneseTitle}</h3>`;
    //       items.forEach(item => {
    //           const row = document.createElement('div');
    //           row.style.display = 'flex';
    //           row.style.alignItems = 'center';
    //           row.style.marginBottom = '3px';

    //           const iconContainer = document.createElement('div');
    //           iconContainer.style.width = '18px';
    //           iconContainer.style.height = '18px';
    //           iconContainer.style.borderRadius = '50%';
    //           iconContainer.style.overflow = 'hidden';
    //           iconContainer.style.marginRight = '5px';
    //           iconContainer.style.display = 'flex';
    //           iconContainer.style.justifyContent = 'center';
    //           iconContainer.style.alignItems = 'center';

    //           if (title === 'type') {
    //               iconContainer.style.backgroundColor = colorGetter(item);
    //           }

    //           const img = document.createElement('img');
    //           img.src = iconGetter(item);
    //           img.alt = item;
    //           img.style.width = '17px';
    //           img.style.height = '17px';

    //           iconContainer.appendChild(img);
    //           row.appendChild(iconContainer);

    //           const span = document.createElement('span');
    //           span.textContent = item;
    //           span.style.fontSize = '15px';
    //           row.appendChild(span);

    //           section.appendChild(row);
    //       });
    //       legend.appendChild(section);
    //   };

    //   createLegendSection(
    //       'animal',
    //       this.legendData.animal,
    //       item => this.animalIcons[item],
    //       null
    //   );
    //   createLegendSection(
    //       'type',
    //       this.legendData.type,
    //       item => this.typeIcons[item],
    //       item => this.typeColors[item]
    //   );
    //   createLegendSection(
    //       'fence',
    //       this.legendData.fence,
    //       item => {
    //           const canvas = document.createElement('canvas');
    //           canvas.width = 20;
    //           canvas.height = 20;
    //           const ctx = canvas.getContext('2d');
    //           ctx.strokeStyle = this.fenceColors[item] || '#000000';
    //           ctx.lineWidth = 3;
    //           ctx.beginPath();
    //           ctx.moveTo(0, 10);
    //           ctx.lineTo(20, 10);
    //           ctx.stroke();
    //           return canvas.toDataURL();
    //       },
    //       null
    //   );

    //   // ウィンドウのリサイズイベントに対応
    //   window.addEventListener('resize', () => {
    //       const mapContainer = document.getElementById('map');
    //       if (mapContainer) {
    //           legend.style.left = '10px';
    //           legend.style.bottom = '10px';
    //       }
    //   });
    //  },

    /**
     * 表示設定ポップアップ用UI行の生成処理
     *
     * チェックボックス +（任意）アイコン + ラベル の1行分のDOMを生成する
     *
     * @param {string} id - チェックボックスのID属性
     * @param {string} labelText - 表示ラベル文字列
     * @param {boolean} checked - 初期チェック状態
     * @param {Function|null} iconGetter - アイコンURLを取得する関数（labelTextを引数に取る）
     * @param {Function|null} colorGetter - 背景色を取得する関数（labelTextを引数に取る）
     * @returns {{row: HTMLElement, checkbox: HTMLInputElement}}
     *          row：生成された1行分のDOM要素
     *          checkbox：生成されたチェックボックス要素
     */
    createDisplaySettingsPopupUI(id, labelText, checked, iconGetter, colorGetter) {

      // ===== 行コンテナ生成 =====
      const row = document.createElement("div");
      row.classList.add("settings-item-row");

      /* ===== checkbox（チェックボックス生成） ===== */

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.id = id;
      checkbox.checked = checked;

      row.appendChild(checkbox);

      /* ===== icon（アイコン生成） ===== */
      
      // アイコン外枠（背景色用）
      const iconContainer = document.createElement("div");
      iconContainer.classList.add("settings-icon-container");
    
      // 背景色設定（種別カラー等）
      if (colorGetter) {
        iconContainer.style.backgroundColor = colorGetter(labelText);
      }
      
      // アイコン画像設定
      if (iconGetter) {
        const iconSrc = iconGetter(labelText);
          
        if (iconSrc) {
          const img = document.createElement("img");
          img.src = iconSrc;
          img.alt = labelText;
          img.classList.add("settings-icon-img");
          iconContainer.appendChild(img);
        }
      }
      
        row.appendChild(iconContainer);
    
      /* ===== text（ラベル生成） ===== */
    
      const label = document.createElement("label");
      label.htmlFor = id; // チェックボックスと関連付け
      label.textContent = labelText;
      label.classList.add("settings-label-text");
    
      row.appendChild(label);

      // 生成したDOMとcheckboxを返却
      return { row, checkbox };
    },


    /**
     * マップ上の動物マーカーとフェンスポリラインを更新します
     * 
     * 主な処理内容:
     * 1. 現在表示中のマーカーやポリラインを削除します
     * 2. 動物データを取得し、表示設定に応じてマーカーを再生成します
     * 3. フェンスデータを取得し、表示設定に応じてポリラインを再生成します
     * 
     * 注意点:
     * - マーカーとポリラインの削除後に、新しいデータに基づいて再生成を行います
     * - 表示設定（動物種別、インシデントタイプ、フェンス種別）に応じて表示内容が制御されます
     */
    async updateWildlifeAndFenceDisplay(displayData) {
      const requestId = ++this.currentRequestId;
      if (!displayData) {
        displayData = this.displayData;
      }
      this.removeWildlifeMarkers(); // 既存のマーカーを削除
      this.removePolylines(); // 既存のポリラインを削除

      const dummyAnimalData = await this.fetchAndFormatWildlifeData(displayData); // 獣種・種別データ取得
      const fenceData = await this.fetchAndFormatFenceData(); // フェンスデータ取得

      // 獣種と種別の選択状態を確認
      const isAnyAnimalSelected = Object.values(displayData.animal).some(value => value);
      const isAnyIncidentSelected = Object.values(displayData.type).some(value => value);

      // ヒートマップの選択状態を確認
      const isAnyHeatMapSelected = Object.values(displayData.heatMap).some(value => value);

      //被害金額
      const isDamageAmountSelected = displayData.heatMap["被害金額"];
      //生息領域
      const isHabitatAreaSelected = displayData.heatMap["生息領域"];
 
      const markerPositions = new Map(); // 既存の座標を記録するマップ

      // 被害金額ヒートマップ情報を格納
      let damageAmountHeatmapData = [];
      // 生息領域ヒートマップ情報を格納
      let habitatAreaHeatmapData = [];
      this.markerloaded = false;
      this.markerloadedCount = 0;
      this.markerloadedTotalCount = 0;
      dummyAnimalData.forEach((data, index, array) => {
          if (index === array.length - 1) {
            this.markerloaded = true;
          }

          const isAnimalVisible = displayData.animal[data.animalType];
          const isIncidentVisible = displayData.type[data.incidentType];

          var shouldDisplay;
		  var icon_flg;
		  // 2026/04/30 RFJ R.Komatsu 両方選択されている場合ANDにならない
		  // 両方選択時はAND、片方選択時は未選択側は全てにする
          if (isAnyAnimalSelected && isAnyIncidentSelected) {
            shouldDisplay = isAnimalVisible && isIncidentVisible;
            icon_flg = (data.incidentType=='捕獲' ||
               data.incidentType=='目撃' || data.incidentType=='痕跡');
          } else if (isAnyAnimalSelected) {
            shouldDisplay = isAnimalVisible;
			icon_flg = true;	// 獣種でアイコンを変える
          } else if (isAnyIncidentSelected) {
            shouldDisplay = isIncidentVisible;
			icon_flg = false;	// 種別でアイコンを変える
          } else
            shouldDisplay = false;

          if (shouldDisplay) {
              this.markerloadedTotalCount++;

              // 背景色の設定
              let backgroundColor = this.typeColors[data.incidentType];
			  // アイコンの設定 2026/04/30 changed by RFJ R.Komatsu
              let iconUrl = icon_flg
 				? this.animalIcons[data.animalType]
                : this.typeIcons[data.incidentType];
              // 同じ座標がある場合は少しずらす**
              const key = `${data.lat},${data.lng}`;
              let shiftIndex = markerPositions.get(key) || 0; // 既にある数を取得

              // ずらし量 (±0.0001のランダム値)
              const latShift = 0.000001 * (Math.random() * 100 - 50);
              const lngShift = 0.000001 * (Math.random() * 100 - 50);

              const adjustedLat = data.lat + latShift;
              const adjustedLng = data.lng + lngShift;

              // 次のマーカー用に shiftIndex を増やす
              markerPositions.set(key, shiftIndex + 1);
              // const marker = new google.maps.Marker({
              //     position: { lat: adjustedLat, lng: adjustedLng },
              //     map: this.map,
              //     icon: {
              //         url: this.animalIcons[data.animalType] || this.typeIcons[data.incidentType],
              //         scaledSize: new google.maps.Size(30, 30), // アイコンのサイズを指定 (幅30px, 高さ30px)
              //     },
              //     title: `${data.animalType} (${data.incidentType})`,
              // });
              // // ダブルクリックリスナーを追加
              // marker.addListener('dblclick', () => {
              //     //console.log("マーカーがダブルクリックされました:", data);
              //     this.showWildlifeDetailsPopup(data, adjustedLat, adjustedLng); // ダブルクリック時に詳細ポップアップを表示
              // });

              // カスタム Marker を作成（AdvancedMarkerElement の代替）
              const canvas = document.createElement("canvas");
              canvas.width = 50;
              canvas.height = 50;
              const ctx = canvas.getContext("2d");

              // 背景円を描画
              ctx.fillStyle = backgroundColor;
              ctx.beginPath();
              ctx.arc(25, 25, 25, 0, Math.PI * 2);
              ctx.fill();

              // 画像を読み込んで描画
              const img = new Image();
              img.crossOrigin = "anonymous"; // 画像が外部URLなら必要
              img.src = iconUrl;
              img.onload = () => {
                if (this.currentRequestId !== requestId) return;
                ctx.save();
                ctx.beginPath();
                ctx.arc(25, 25, 25, 0, Math.PI * 2);
                ctx.clip();
                ctx.drawImage(img, 0, 0, 50, 50);
                ctx.restore();

                // 画像が描画された canvas を icon に使う Marker を作成
                const marker = new google.maps.Marker({
                  position: { lat: adjustedLat, lng: adjustedLng },
                  map: null, // まだ地図には追加しない
                  icon: {
                    url: canvas.toDataURL(),
                    scaledSize: new google.maps.Size(50, 50),
                  },
                  title: `${data.animalType} (${data.incidentType})`,
                });

                // 双クリックイベント
                marker.addListener("dblclick", () => {
                  this.showWildlifeDetailsPopup(data, adjustedLat, adjustedLng);
                });

                // データIDなどを保存
                marker.dataId = data.id;
                marker.latLng = new google.maps.LatLng(adjustedLat, adjustedLng);

                // Vue 反応システムに干渉しないよう markRaw
                this.wildlifeMarkersData.push(markRaw(marker));
                this.markerloadedCount++;
                if (this.markerloaded && this.markerloadedCount === this.markerloadedTotalCount) {
                  if (this.currentRequestId !== requestId) return;
				  // 2026/05/01 Changed by RFJ R.Komatsu 選択未反映対応
                  //toRaw(this.wildlifeMarkerClusterer).clearMarkers();
                  markRaw(this.wildlifeMarkerClusterer).clearMarkers();
                  this.wildlifeMarkerClusterer.addMarkers(this.wildlifeMarkersData);
                }
              };
          }

          //if (isAnyHeatMapSelected) {
          //  // ヒートマップに使用するデータを配列に格納
          //  heatmapData.push(
          //    new google.maps.LatLng(data.lat, data.lng)
          //  );
          //}
          //被害金額
          if (isDamageAmountSelected) {
            //種別が「被害」の場合
            if (!data.isHokaku && data.incidentType === '被害') {
              //被害金額（万円単位）より表示
              const count = Math.ceil(Number(data.damageAmount) / 10000);
              damageAmountHeatmapData.push(
                { location: new google.maps.LatLng(data.lat, data.lng), weight: count }
              );
            }
          }
          //生息領域
          if (isHabitatAreaSelected) {
            //種別が「目撃」、「捕獲」、「痕跡」の場合
            if (!data.isHokaku && (data.incidentType === '目撃' || data.incidentType === '捕獲' || data.incidentType === '痕跡')) {
              //頭数より表示
              habitatAreaHeatmapData.push(
                { location: new google.maps.LatLng(data.lat, data.lng), weight: Number(data.count) }
              );
            }
          }
      });
      
      if (this.markerloadedTotalCount === 0) {
        this.removeWildlifeMarkers();
      }

      if (isAnyHeatMapSelected) {

        //if (!this.heatmapLayer) {
          // ヒートマップを地図情報に紐づけ
          // おまけ： https://qiita.com/mo49/items/61c7aa15591a2a8ca260
        //  this.heatmapLayer = new google.maps.visualization.HeatmapLayer({
        //    radius: 30,
        //    dissipating: true
        //  });
        //}
      
        //this.heatmapLayer.setData(heatmapData);
        //this.heatmapLayer.setMap(this.map);
        //被害金額
        if (isDamageAmountSelected) {
          if (this.damageAmountHeatmapLayer) {
            toRaw(this.damageAmountHeatmapLayer).setMap(null);
          }
          this.damageAmountHeatmapLayer = new google.maps.visualization.HeatmapLayer({
            radius: 30,
            dissipating: true,
            gradient: this.pinkGradient,
          });
          this.damageAmountHeatmapLayer.setData(damageAmountHeatmapData);
          this.damageAmountHeatmapLayer.setMap(this.map);
        } else if (this.damageAmountHeatmapLayer) {
          toRaw(this.damageAmountHeatmapLayer).setMap(null);
        }
        //生息領域
        if (isHabitatAreaSelected) {
          if (this.habitatAreaHeatmapLayer) {
            toRaw(this.habitatAreaHeatmapLayer).setMap(null);
          }
          this.habitatAreaHeatmapLayer = new google.maps.visualization.HeatmapLayer({
            radius: 30,
            dissipating: true,
            maxIntensity: 5,
            gradient: this.skyBlueGradient,
          });
          this.habitatAreaHeatmapLayer.setData(habitatAreaHeatmapData);
          this.habitatAreaHeatmapLayer.setMap(this.map);
        } else if (this.habitatAreaHeatmapLayer) {
          toRaw(this.habitatAreaHeatmapLayer).setMap(null);
        }
      
      } else {
        if (this.damageAmountHeatmapLayer) {
          toRaw(this.damageAmountHeatmapLayer).setMap(null);
        }
        if (this.habitatAreaHeatmapLayer) {
          toRaw(this.habitatAreaHeatmapLayer).setMap(null);
        }
    }


      // 柵種のポリラインも再生成
      fenceData.forEach((fenceData, index) => {
          // const isFenceVisible = this.displayData.fence['すべて'] || this.displayData.fence[fenceData.type];
          const isFenceVisible = displayData.fence[fenceData.type];
          if (Array.isArray(fenceData.path) && isFenceVisible) { // 表示設定に応じて処理
              const polyline = new google.maps.Polyline({
                  path: fenceData.path,
                  strokeColor: this.fenceColors[fenceData.type] || '#000000',
                  strokeOpacity: 1.0,
                  strokeWeight: 3,
                  map: this.map,
                  optimized: false, // 最適化を無効化
              });

              polyline.fenceDetails = this.createFenceDetails(fenceData, index);

              //console.log("更新後のポリライン詳細情報:", polyline.fenceDetails);

              google.maps.event.clearInstanceListeners(polyline);
              polyline.addListener("dblclick", () => {
                  // console.log("更新後のポリラインがダブルクリックされました:", polyline.fenceDetails.id);
                  this.showFencePopup("edit", polyline.fenceDetails.id);
              });

              this.polylines.push(polyline);
          } else {
              console.info("表示設定によりスキップされたフェンスデータ:", fenceData);
          }
      });
      // this.createLegend(); //凡例を更新
    },
    // 詳細情報ポップアップを表示するメソッド
    showWildlifeDetailsPopup(data, adjustedLat, adjustedLng) {
      const existingPopup = document.querySelector('.draggable-popup');
      if (existingPopup) {
          existingPopup.remove();
      }

      // 日付をフォーマットする関数（時間を切り、登録日に変更）
      const formatDate = (isoString) => {
        if (!isoString) return '不明';
        // UTC日時から日本時間に変換
        const date = new Date(isoString);
        // JST (UTC + 9時間)に変換
        date.setHours(date.getHours() + 9);
        // フォーマット: yyyy/mm/dd
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
        const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に

        return `${year}/${month}/${day}`;
      };

      // 日時をフォーマットする関数（yyyy/mm/dd hh:mm:ss形式）
      const formatDateTime = (isoString) => {
        if (!isoString) return '不明';
        // UTC日時を日本時間に変換
        const date = new Date(isoString);
        // JST (UTC + 9時間)に変換
        date.setHours(date.getHours() + 9);
        // フォーマット: yyyy/mm/dd hh:mm:ss
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
        const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に
        const hours = String(date.getHours()).padStart(2, '0'); // 時を2桁に
        const minutes = String(date.getMinutes()).padStart(2, '0'); // 分を2桁に
        const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒を2桁に

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
      };
      const popup = document.createElement('div');
      popup.className = 'draggable-popup';
      popup.style.position = 'absolute';
      popup.style.zIndex = '1000';
      popup.style.width = '300px';
      popup.style.padding = '10px 25px';
      popup.style.backgroundColor = '#d4f1c5';
      popup.style.border = '1px solid #ccc';
      popup.style.borderRadius = '5px';
      popup.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)';
      popup.style.cursor = 'move';

      popup.innerHTML = `
          <h2>獣害情報
          <label style="color:green">（${data.incidentType}）</label>
		  </h2>
          <!--p><strong>登録:</strong> ${formatDate(data.createDate)}</p-->
          <p><strong>日時:</strong> ${formatDateTime(data.damageDate)}</p>
          <p><strong>獣種:</strong> ${data.animalType}</p>
          <p><strong>報告:</strong> ${data.nameKanji || '不明'}</p>
		  <p>
          ${data.imageUrl  ? `<img src="${data.imageUrl}" alt="画像1" style="max-width: 100px; max-height: 100px;" />` : ''}
          ${data.imageUrl1 ? `<img src="${data.imageUrl1}" alt="画像2" style="max-width: 100px; max-height: 100px;" />` : ''}
          ${data.imageUrl2 ? `<img src="${data.imageUrl2}" alt="画像3" style="max-width: 100px; max-height: 100px;" />` : ''}
		  </p>
          <button id="close-popup" class="close-button" style="display: block; margin: 10px auto;">閉じる</button>
      `;

      popup.querySelector('#close-popup').addEventListener('click', () => {
          this.popupDetailControlRoot.removeChild(popup);
      });

      const overlay = new google.maps.OverlayView();
      overlay.onAdd = function () {};
      overlay.draw = function () {
          const projection = this.getProjection();
          const position = projection.fromLatLngToDivPixel(new google.maps.LatLng(adjustedLat, adjustedLng));
          popup.style.left = `${position.x + window.innerWidth / 2 - 150}px`;
          popup.style.top = `${position.y + window.innerHeight / 2 - 100}px`;
      };
      overlay.onRemove = function () {};

      overlay.setMap(this.map);
      this.popupDetailControlRoot.appendChild(popup);
      this.enablePopupDragging(popup);
    },

    /*データ管理*/

    // 種別を双方向マッピングする関数
    mapIncidentType(value, direction = "toString") {
      const typeMap = {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "6": "柵",
        "9": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    // 獣種を双方向マッピングする関数
    mapAnimalType(value, direction = "toString") {
      const typeMap = {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    // フェンス種別を双方向マッピングする関数
    mapFenceType(value, direction = "toString") {
      const typeMap = {
        "1": "電気",
        "2": "金属",
        "3": "ネット",
        "4": "ワイヤーメッシュ",
        "9": "その他",
      };

      if (direction === "toString") {
        // 数値コード -> 日本語文字列
        return typeMap[value] || "不明";
      } else if (direction === "toCode") {
        // 日本語文字列 -> 数値コード
        const reversedMap = Object.entries(typeMap).reduce((acc, [key, val]) => {
          acc[val] = key;
          return acc;
        }, {});
        return reversedMap[value] || null;
      }

      throw new Error("無効な変換方向が指定されました");
    },

    //鳥獣被害情報（アイコン情報）の取得
    async fetchAndFormatWildlifeData(displayData) {
      try {
        // API呼び出し
        const userId = localStorage.getItem("userId");
        const section = localStorage.getItem("section");
        const regionId = localStorage.getItem("regionId");
        const requestData = { id: userId, section: section };
        const response = await wildlifeDamageMapApi.getWildlifeDamageList(requestData);
        let hokakuAllData = [];
        if (displayData.type?.捕獲) {
          hokakuAllData = await wildlifeDamageMapApi.getHokakuList(regionId, this.searchForm.date_begin, this.searchForm.date_end);
        }
        
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }

        // APIレスポンスデータの取得
        let allData;
        if (section !== '0000') {
          allData = response.data.data.filter(org =>
            org.region_Id === regionId
          );
        } else {
          allData = response.data.data;
        }

        if (!allData || !Array.isArray(allData)) {
          console.error("期待するデータ形式ではありません:", allData);
          return [];
        }

        // 鳥獣被害情報に関するデータを抽出
        const wildlifeData = allData.filter(record => {
          // 削除フラグが "1" の場合はスキップ
          if (record.deleteFlg === "1") {
            return false;
          }

          // `type` が 6 の場合はスキップ
          if (record.type === "6") {
            return false;
          }

          // 必須データが欠けている場合はスキップ
          if (!record.locationLat || !record.locationLon || !record.type) {
            return false;
          }

		  // 2026/04/10 Addedby RFJ R.Komatsu
		  var isMatched = false;
          const itemDateStr = record.damageDate;
          if (itemDateStr) {
            const itemDate = new Date(itemDateStr);
            const fromDate = this.searchForm.date_begin
				? new Date(this.searchForm.date_begin) : null;
            const toDate = this.searchForm.date_end
				? new Date(this.searchForm.date_end) : null;
            // 日付だけで判断する、時間はJSTにパッチ
            itemDate.setHours(itemDate.getHours()+9);
            itemDate.setHours(0, 0, 0, 0);
            if (fromDate && toDate) {
              fromDate.setHours(0, 0, 0, 0);
              toDate.setHours(0, 0, 0, 0);
              isMatched = itemDate >= fromDate && itemDate <= toDate;
            } else if (fromDate) {
              fromDate.setHours(0, 0, 0, 0);
              isMatched = itemDate >= fromDate;
            } else if (toDate) {
              toDate.setHours(0, 0, 0, 0);
              isMatched = itemDate <= toDate;
            } else {
              isMatched = true;
            }
          }
		  return isMatched;
          //return true; // 必要なデータのみ通す
        });

        // 「捕獲」はスマートHOKAKUから連携した捕獲データを抽出
        const hokakuData = hokakuAllData.filter(record => {
          // 削除フラグが "1" の場合はスキップ
          if (record.deleteFlg === "1") {
            return false;
          }

          // `type` が 6 の場合はスキップ
          if (record.type === "6") {
            return false;
          }

          // 必須データが欠けている場合はスキップ
          if (!record.locationLat || !record.locationLon || !record.type) {
            return false;
          }

          return true; // 必要なデータのみ通す
        });

        // 抽出したデータをマッピングして整形
        this.formattedWildlifeData = wildlifeData.map(record => ({
          id: `${record.region_Id}-${record.no}-${record.id}`, // 主キーを結合して一意なIDを生成
          primaryKey: {
            regionId: record.region_Id,
            no: record.no,
            id: record.id,
          }, // 主キー情報を保持
          lat: Number(record.locationLat), // 緯度を数値型に変換
          lng: Number(record.locationLon), // 経度を数値型に変換
          animalType: this.mapAnimalType(record.animalType, "toString"), // 獣種
          incidentType: this.mapIncidentType(record.type, "toString"), // 種別
          nameKanji: record.nameKanji,
          imageUrl: record.imageUrl,
          imageUrl1: record.imageUrl1,
          imageUrl2: record.imageUrl2,
          damageDate: record.damageDate,
          createDate: record.createDate,
          modifyDate: record.modifyDate,
          damageAmount: record.damageAmount, //被害金額
          count: record.count, //頭数
          isHokaku: false
        }));

        //種別の「捕獲」はスマートHOKAKUから連携した捕獲を追加して表示する
        hokakuData.forEach(record => {
          this.formattedWildlifeData.push({
            id: `${record.region_id}-${record.no}-${record.user_id}`,
            primaryKey: {
              regionId: record.region_id,
              no: record.no,
              id: record.user_id,
            },
            lat: Number(record.locationLat),
            lng: Number(record.locationLon),
            animalType: this.mapAnimalType(record.animalType, "toString"),
            incidentType: this.mapIncidentType(record.type, "toString"),
            nameKanji: '',
            imageUrl: record.imageUrl,
            imageUrl1: record.imageUrl1,
            imageUrl2: record.imageUrl2,
            damageDate: record.damageDate,
            createDate: record.createDate,
            modifyDate: record.modifyDate,
            damageAmount: 0, //被害金額
            count: 0, //頭数
            isHokaku: true
          });
        });

        //console.log("整形された鳥獣被害データ:", formattedWildlifeData);
        return this.formattedWildlifeData;

      } catch (error) {
        console.error("鳥獣被害データの取得に失敗しました:", error);
        return []; // エラーハンドリングとして空配列を返す
      }
    },

    //柵情報の取得
    async fetchAndFormatFenceData() {
      try {
        // API呼び出し
        const userId = localStorage.getItem("userId");
        const section = localStorage.getItem("section");
        const regionId = localStorage.getItem("regionId");
        const requestData = { id: userId, section: section };
        const response = await wildlifeDamageMapApi.getWildlifeDamageList(requestData);
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }

        let allData;
        if (section !== '0000') {
          allData = response.data.data.filter(org =>
            org.region_Id === regionId
          );
        } else {
          allData = response.data.data;
        }

        if (!allData || !Array.isArray(allData)) {
          console.error('期待するデータ形式ではありません:', allData);
          return [];
        }

        // 柵情報に関するデータのみを抽出
        const fenceData = allData.filter(record => {
          // `deleteFlg` が "1" の場合はスキップ
          if (record.deleteFlg === "1") {
            //console.warn("削除フラグが立っているレコードをスキップ:", record);
            return false; // スキップ
          }
          // `type` が 6 以外の場合はスキップ
          if (record.type !== "6") {
            //console.warn("typeが6ではないレコードをスキップ:", record);
            return false; // スキップ
          }
          if (!record.fenceType || !record.fencePath) {
            //console.warn("柵情報が不完全なレコードをスキップ:", record);
            return false; // `null` なデータをスキップ
          }

		  // 2026/04/23 RFJ R.Komatsu 日付範囲を正しく実装する
        	var isDateMatched = true;
        	const dateF = this.searchForm.date_begin
				? new Date(this.searchForm.date_begin) : null;
        	const dateT = this.searchForm.date_end
				? new Date(this.searchForm.date_end) : null;

        	const idate = record.fenceInstDate;
        	const rdate = record.fenceRemoDate;
			var dateI;
			// 導入日の比較
			if (idate) {
          		dateI = new Date(idate);
          		dateI.setHours(0,0,0,0);

				if (dateT) {
					dateT.setHours(0,0,0,0);
					if (dateI > dateT) isDateMatched = false;
				}
			}
			// 撤去日の比較
			if (rdate) {
          		dateI = new Date(rdate);
          		dateI.setHours(0,0,0,0);

				if (dateF) {
					dateF.setHours(0,0,0,0);
					if (dateF > dateI) isDateMatched = false;
				}
			}
          	return isDateMatched;
        });

        // 日付フォーマットを変更する関数
        const formatDate = (dateString) => {
          if (!dateString) return null; // nullまたはundefinedの場合そのまま返す
          // UTC日時をDateオブジェクトに変換
          const date = new Date(dateString);
          // JST (UTC + 9時間)に変換
          date.setHours(date.getHours() + 9);
          // フォーマット: yyyy-mm-dd
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
          const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に

          return `${year}-${month}-${day}`;
        };

        // 抽出したデータをマッピングして整形
        this.formattedFenceData = fenceData.map(fence => ({
          id: `${fence.region_Id}-${fence.no}-${fence.id}`, // 主キーを結合して一意なIDを生成
          primaryKey: { 
            regionId: fence.region_Id, 
            no: fence.no, 
            id: fence.id 
          }, // 主キー情報を持たせる
          type: this.mapFenceType(fence.fenceType, "toString"), // 数値コード -> 日本語文字列
          path: JSON.parse(fence.fencePath), // JSON形式で保存された座標リストをパース
          details: {
            name: fence.fenceName, // `fenceName` を `details.name` にマッピング
            length: fence.fenceLength, // `fenceLength` を `details.length` にマッピング
            installDate: formatDate(fence.fenceInstDate), // 日付フォーマットを修正
            removeDate: formatDate(fence.fenceRemoDate), // 日付フォーマットを修正
            additionalNotes: fence.fencememo, // `fencememo` を `details.additionalNotes` にマッピング
          },
        }));

        //console.log("整形されたフェンスデータ:", formattedFenceData);
        return this.formattedFenceData;

      } catch (error) {
        console.error('フェンスデータの取得に失敗しました:', error);
        return []; // エラーハンドリングとして空配列を返す
      }
    },

    //柵情報の登録更新処理
    async saveFenceDataToDB(fenceData) {
      try {
          // 柵種を数値コードに変換
          const fenceTypeCode = this.mapFenceType(fenceData.type, "toCode");
          if (!fenceTypeCode) {
              console.error(`サポートされていない柵種: ${fenceData.type}`);
              throw new Error(`無効な柵種: ${fenceData.type}`);
          }

          // DBに送信するデータのペイロード
          const regionId = localStorage.getItem("regionId");
          const payload = {
              details: {
                  regionId: regionId,
                  fenceType: fenceTypeCode,
                  fenceName: fenceData.details.name,
                  fenceLength: fenceData.details.length,
                  fenceInstDate: fenceData.details.installDate,
                  fenceRemoDate: fenceData.details.removeDate,
                  fencememo: fenceData.details.additionalNotes,
                  fencePath: JSON.stringify(fenceData.path),
              },
          };

          // 登録と更新を判定
          const isUpdate = !!fenceData.primaryKey;

          if (isUpdate) {
              // 更新時のペイロード構造
              payload.primaryKey = {
                  region_Id: fenceData.primaryKey.regionId,
                  no: fenceData.primaryKey.no,
                  id: fenceData.primaryKey.id,
              };
          } else {
              // 登録時の追加フィールド
              payload.details.creatorId = fenceData.details.creatorId;
          }

          // console.log("登録/更新するペイロード:", payload);

          // APIにデータ送信
          let response;
          if (isUpdate) {
              response = await wildlifeDamageMapApi.updateFence(payload); // 更新
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert("データを更新しました");
          } else {
              response = await wildlifeDamageMapApi.registerFence(payload); // 登録
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert("新しいデータを登録しました");
          }
          this.removePolylines(); // 既存のポリラインを削除
          await this.initializeFencePolylines(this.map); // 新しいデータで再描画
      } catch (error) {
          console.error("データ保存中にエラーが発生しました:", error);
          alert("データ保存中にエラーが発生しました");
      }
    },

    //柵情報の論理削除
    async deleteFenceData(primaryKey) {
      try {
          // `primaryKey` の存在を確認
          if (!primaryKey || !primaryKey.regionId || !primaryKey.no || !primaryKey.id) {
              console.error("削除処理の primaryKey が不足しています:", primaryKey);
              throw new Error("削除対象のプライマリキーが正しくありません");
          }

          // DBに送信する削除用ペイロード
          const payload = {
              primaryKey: {
                  region_Id: primaryKey.regionId, // regionId を region_Id に変換
                  no: primaryKey.no,
                  id: primaryKey.id,
              },
          };

          // APIに削除リクエストを送信
          const response = await wildlifeDamageMapApi.deleteFence(payload);

          if (response && response.data.message === "削除成功") {
              // 新しいトークンがレスポンスヘッダーに含まれている場合
              const newToken = response.headers.get('Authorization');
              if (newToken) {
                  localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
              }
              alert(`削除が完了しました`);
          } else {
              console.error("削除APIから想定外のレスポンスが返されました:", response);
              alert("削除処理に失敗しました");
          }

          // 再描画
          this.removePolylines(); // 既存のポリラインを削除
          await this.initializeFencePolylines(this.map); // 新しいデータで再描画
          this.resetMap();
      } catch (error) {
          alert(`エラーが発生しました（エラーコード：${error.response.status}）`);
      }
    },

    
    saveDisplayDataToLocalStorage(displayData) {
      const storageKey = "displaySettings";
      localStorage.setItem(storageKey, JSON.stringify(displayData));
      // console.log("表示設定をローカルストレージに保存しました:", this.displayData);
    },

    saveLayoutDataToLocalStorage() {
      const storageKey = "layoutSettings";
      localStorage.setItem(storageKey, JSON.stringify(this.layoutData));
      // console.log("表示設定をローカルストレージに保存しました:", this.displayData);
    },

    // ローカルストレージからフェンスデータを取得（DB接続前用）
    getFenceData() {
      const storageKey = "fenceData";
      const storedData = localStorage.getItem(storageKey);

      // ローカルストレージにデータがない場合、デフォルトデータを保存して返す
      if (!storedData) {
        console.warn("ローカルストレージにデータが見つかりません、デフォルトデータを保存します");

        // デフォルトデータをローカルストレージに保存
        localStorage.setItem(storageKey, JSON.stringify(this.defaultFenceData));

        // デフォルトデータを返す
        return this.defaultFenceData;
      }

      // JSON解析に失敗する可能性をキャッチする
      try {
        const parsedData = JSON.parse(storedData);

        // 必要に応じてIDを数値型に変換
        return parsedData.map(fence => ({
          ...fence,
          id: Number(fence.id),
        }));
      } catch (error) {
        console.error("ローカルストレージのデータ解析に失敗しました:", error);

        // ローカルストレージをリセットしてデフォルトデータに戻す
        console.warn("ローカルストレージをデフォルトデータにリセットします");
        localStorage.setItem(storageKey, JSON.stringify(this.defaultFenceData));
        return this.defaultFenceData;
      }
    },
    
    // フェンスデータをローカルストレージに保存する（DB接続前用）
    async updateFenceData(updatedFence) {
      const storageKey = "fenceData";
      const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];

      const index = storedData.findIndex(fence => Number(fence.id) === Number(updatedFence.id));
      //console.log("更新対象インデックス:", index);

      if (index !== -1) {
        storedData[index] = updatedFence; // 既存データを更新
        //console.log(`ID "${updatedFence.id}" のデータが更新されました`);
      } else {
        storedData.push(updatedFence); // 新規データを追加
        //console.log(`新しいデータが追加されました:`, updatedFence);
      }

      // データ形式を検証
      if (!Array.isArray(updatedFence.path) || updatedFence.path.some(point => !point.lat || !point.lng)) {
        console.error("保存するデータに無効なパス情報があります:", updatedFence.path);
        return;
      }

      // 更新されたデータをローカルストレージに保存
      localStorage.setItem(storageKey, JSON.stringify(storedData)); // ローカルストレージを更新
      //console.log("更新後のデータ:", storedData);

      
      this.removePolylines(); // 既存のポリラインを削除
      await this.initializeFencePolylines(this.map); // 新しいデータで再描画
    },

    // ローカルストレージからフェンスを削除（DB接続前用）
    removeFenceFromLocalStorage(fenceId) {
      const storageKey = "fenceData";
      const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];

      // 削除時にidを数値として比較
      const updatedData = storedData.filter(fence => Number(fence.id) !== Number(fenceId));

      localStorage.setItem(storageKey, JSON.stringify(updatedData));
      //console.log(`ID "${fenceId}" のデータが削除されました`, updatedData);
    },

    /*ポップアップ管理*/

    //ポップアップをドラッグ可能にする
    enablePopupDragging(element) {
        let offsetX = 0;
        let offsetY = 0;
        let isDragging = false;

        element.addEventListener("mousedown", (e) => {
            isDragging = true;
            offsetX = e.clientX - element.offsetLeft;
            offsetY = e.clientY - element.offsetTop;
            element.style.cursor = "grabbing"; // カーソルを変更
        });

        document.addEventListener("mousemove", (e) => {
            if (isDragging) {
                element.style.left = `${e.clientX - offsetX}px`;
                element.style.top = `${e.clientY - offsetY}px`;
            }
        });

        document.addEventListener("mouseup", () => {
            isDragging = false;
            element.style.cursor = "move"; // カーソルを戻す
        });
    },

    // 柵編集/登録ポップアップの生成
    async buildFencePopupContent(mode, id = null) {
      
      //console.log("Popupに渡されたmode:", mode, "id:", id);

      const commentContainer = document.createElement("div");
      commentContainer.classList.add("comment-popup");

      // 子画面タイトル
      const title = document.createElement("h2");
      title.innerHTML = mode === "edit" ? "柵編集" : "新しい柵を追加";
      commentContainer.appendChild(title);

      // デフォルトのデータ（新規登録の場合）
      let details = {
        id: null,
        type: mode === "new" ? "電気" : "", // 新規登録の場合はデフォルトで「電気」
        name: "",
        length: "",
        installDate: "",
        removeDate: "",
        additionalNotes: "",
        path: [],
      };
      // 新規登録モードの場合にポリラインの色を初期化
      if (mode === "new") {
        // 初期ポリラインの色を「電気」に設定
        if (this.polylines.length > 0) {
          const newPolyline = this.polylines[this.polylines.length - 1];
          newPolyline.setOptions({
            strokeColor: this.fenceColors["電気"], // 初期化時に「電気」の色を設定
          });
        }
      }

      if (mode === "edit" && id !== null) {
        const allFences = await this.fetchAndFormatFenceData(); // データを取得
        const targetFence = allFences.find((fence) => fence.id === id);
        // console.log("対象フェンス:", targetFence); // 見つかったフェンスデータをログに出力

        if (targetFence) {
            details = {
                ...details,
                ...targetFence.details,
                id: targetFence.id,
                type: targetFence.type,
                path: targetFence.path,
                primaryKey: targetFence.primaryKey, // primaryKeyを追加
            };
        } else {
          console.warn("該当する柵データが見つかりませんでした");
        }
      }

      // 元の柵種を保存しておく
      var originalFenceType = details.type;

      // データを分離（連動を防ぐ）
      const localDetails = JSON.parse(JSON.stringify(details));

      // ローカル変数で柵種を管理
      let localFenceType = localDetails.type;

      // ラジオボタン: 柵種
      const fenceTypeLabel = document.createElement("div");
      fenceTypeLabel.innerHTML = "柵種";
      commentContainer.appendChild(fenceTypeLabel);

      const types = ["電気", "金属", "ネット", "ワイヤーメッシュ", "その他"];
      types.forEach((type) => {
        const radioContainer = document.createElement("div");
        radioContainer.style.display = "flex";
        radioContainer.style.alignItems = "center";
        radioContainer.style.marginBottom = "8px"; // ラジオボタン間の間隔

        const radio = document.createElement("input");
        radio.type = "radio";
        radio.name = "fenceType";
        radio.id = `fence-${type}`;
        radio.value = type;
        radio.checked = localFenceType === type;
        // ラジオボタン選択時の処理
        radio.addEventListener("change", () => {
          localFenceType = type;
          // console.log("選択された柵種:", type); // 追加
          // console.log("変更前のlocalDetails.type:", localDetails.type); // 追加

          // 新規モードまたは編集モードのポリライン色更新
          if (mode === "new" && this.polylines.length > 0) {
            const newPolyline = this.polylines[this.polylines.length - 1];
            newPolyline.setOptions({
              strokeColor: this.fenceColors[type] || "#000000",
            });
          } else if (mode === "edit") {
            localDetails.type = type; // ローカルデータの更新
            // console.log("更新後のlocalDetails.type:", localDetails.type); // 追加
            this.updatePolylineColor(localDetails);
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `fence-${type}`;
        label.innerHTML = type;

        // 線色のボックス
        const colorBox = document.createElement("div");
        colorBox.style.width = "40px";
        colorBox.style.height = "5px";
        colorBox.style.backgroundColor = this.fenceColors[type] || "#000000";
        colorBox.style.border = "1px solid #000"; // 境界線
        colorBox.style.marginLeft = "8px";

        radioContainer.appendChild(radio);
        radioContainer.appendChild(label);
        radioContainer.appendChild(colorBox);
        commentContainer.appendChild(radioContainer);
      });

      // その他の入力フィールド
      const elements = [{
        type: "text",
        label: "名称",
        key: "name",
        value: localDetails.name,
        required: true,
        maxLength: 128 
      }, {
        type: "text",
        label: "総延長 (km)",
        key: "length",
        value: localDetails.length,
        required: true
      }, {
        type: "date",
        label: "設置日",
        key: "installDate",
        value: localDetails.installDate,
        required: true
      }, {
        type: "date",
        label: "撤去日",
        key: "removeDate",
        value: localDetails.removeDate
      }, {
        type: "textarea",
        label: "追記事項",
        key: "additionalNotes",
        value: localDetails.additionalNotes,
        maxLength: 1000 
      }, ];

      const inputs = {};
      const errors = {}; // エラーメッセージ要素の参照を保持
      elements.forEach(({ type, label, key, value, required, maxLength }) => {
        const fieldContainer = document.createElement("div");
        fieldContainer.classList.add("field-container");

        const labelElement = document.createElement("label");
        labelElement.innerHTML = label;

        // 必須項目の場合に required-label クラスを追加
        if (required) {
          labelElement.classList.add("required-label");
        }

        fieldContainer.appendChild(labelElement);

        let input;
        if (type === "textarea") {
          input = document.createElement("textarea");
          input.style.height = "60px";
        } else {
          input = document.createElement("input");
          input.type = type;
        }
        input.value = value || "";
        input.style.width = "100%";

        inputs[key] = input; // 入力フィールドを保持

        // エラーメッセージ要素を作成
        const errorMessage = document.createElement("span");
        errorMessage.className = "error-message";
        errorMessage.style.display = "none";
        errors[key] = errorMessage;

        // バリデーション処理を追加
        input.addEventListener("blur", () => {
          const error = this.validateField(inputs, key, input.value, required, label, maxLength); // maxLength を渡す
          this.updateErrorDisplay(errorMessage, input, error);
        });

        fieldContainer.appendChild(input);
        fieldContainer.appendChild(errorMessage);
        commentContainer.appendChild(fieldContainer);
      });

      // ボタンコンテナ
      const buttonContainer = document.createElement("div");
      buttonContainer.classList.add("button-container");

      // 戻るボタン（共通）
      const cancelButton = this.createPopupButton("戻る", "cancel-button", () => {
        if (mode === "new") {
          this.removeLastPolyline(); // 新規登録の場合はポリラインを削除
        } else if (mode === "edit" && id !== null) {
        // 編集モードの場合、元の色に戻す
        const polylineToRestore = this.polylines.find(
          (polyline) => polyline.fenceDetails.id === id
        );

        if (polylineToRestore) {
          // 元の色を設定
          const originalColor = this.fenceColors[originalFenceType] || "#000000";
          polylineToRestore.setOptions({
            strokeColor: originalColor,
          });

          // ポリライン情報も元の柵種に戻す
          polylineToRestore.fenceDetails.type = originalFenceType;
        }
      }
        // document.body.removeChild(commentContainer);
        this.popupDetailControlRoot.removeChild(commentContainer);
        this.isFenceEditPopupOpen = false;
      });
      buttonContainer.appendChild(cancelButton);

      // 削除ボタン（編集モードの場合のみ表示、左側に配置）
      if (mode === "edit") {
        const deleteButton = this.createPopupButton("削除", "delete-button",async  () => {

          // 確認メッセージの表示
          const confirmation = confirm("本当に削除しますか");
          if (!confirmation) {
              return; // ユーザーがキャンセルを選んだ場合、削除処理を中断
          }

          // 削除対象
          const primaryKey = {
              regionId: localDetails.primaryKey?.regionId,
              no: localDetails.primaryKey?.no,
              id: localDetails.primaryKey?.id,
          };

          // 削除処理の実行
          await this.deleteFenceData(primaryKey);

          const polylineToRemove = this.polylines.find(polyline => polyline.fenceDetails
            .id === localDetails.id);
          if (polylineToRemove) {
            toRaw(polylineToRemove).setMap(null);
            this.polylines = this.polylines.filter(polyline => polyline !==
              polylineToRemove);
            // 地図全体をリセット
            await this.resetMap();
          }

          // document.body.removeChild(commentContainer);
          this.popupDetailControlRoot.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;

          //console.log(`ID "${localDetails.id}" のデータが削除されました`);
        });
        buttonContainer.appendChild(deleteButton);
      }

      // 「登録」ボタン (新規登録モード)
      if (mode === "new") {
        const registerButton = this.createPopupButton("登録", "register-button",async () => {
          let isValid = true;

          // 全フィールドをバリデーション
          elements.forEach(({ type, label, key, value, required, maxLength }) => {
            const input = inputs[key];
            const errorMessage = errors[key];
            const error = this.validateField(inputs, key, input.value, required, label, maxLength);
            this.updateErrorDisplay(errorMessage, input, error);
            if (error) isValid = false;
          });

          if (!isValid) {
            alert("入力にエラーがあります");
            return;
          }

          // 登録処理
          const newDetails = {
            type: localFenceType, // ローカル変数を利用
            path: this.currentPolylinePath,
            details: {
              name: inputs["name"].value,
              length: inputs["length"].value,
              installDate: inputs["installDate"].value,
              removeDate: inputs["removeDate"].value,
              additionalNotes: inputs["additionalNotes"].value,
            },
          };

          await this.saveFenceDataToDB(newDetails);
          // document.body.removeChild(commentContainer);
          this.popupDetailControlRoot.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;
          // 新しい柵の表示設定を自動的にオンにする
          // 修正後
          if (typeof this.displayData.fence === "object") {
            this.displayData.fence[newDetails.type] = true; // 該当種別の表示をオン
          } else {
            console.error("displayData.fence のデータ型が不正です:", typeof this.displayData.fence);
          }
          await this.updateWildlifeAndFenceDisplay();
          alert("新しい柵を登録しました")
        });
        buttonContainer.appendChild(registerButton);
      }

      // 更新ボタン（編集モード）
      if (mode === "edit") {
        const updateButton = this.createPopupButton("更新", "update-button",async () => {
          let isValid = true;

          // 全フィールドをバリデーション
          elements.forEach(({ type, label, key, value, required, maxLength }) => {
            const input = inputs[key];
            const errorMessage = errors[key];
            const error = this.validateField(inputs, key, input.value, required, label, maxLength);
            this.updateErrorDisplay(errorMessage, input, error);
            if (error) isValid = false;
          });

          if (!isValid) {
            alert("入力にエラーがあります");
            return;
          }

          // 更新処理
          const updatedDetails = {
            primaryKey: {
                regionId: localDetails.primaryKey?.regionId,
                no: localDetails.primaryKey?.no,
                id: localDetails.primaryKey?.id,
            },
            type: localFenceType, // ローカル変数を利用
            path: localDetails.path,
            details: {
              name: inputs["name"].value,
              length: inputs["length"].value,
              installDate: inputs["installDate"].value,
              removeDate: inputs["removeDate"].value,
              additionalNotes: inputs["additionalNotes"].value,
            },
          };

          await this.saveFenceDataToDB(updatedDetails);
          // document.body.removeChild(commentContainer);
          this.popupDetailControlRoot.removeChild(commentContainer);
          this.isFenceEditPopupOpen = false;

          // 再描画
          this.removePolylines();
          await this.initializeFencePolylines(this.map);


          // 修正: 更新した柵種の表示設定をオンにする
          if (typeof this.displayData.fence === "object") {
            this.displayData.fence[updatedDetails.type] = true; // 該当種別の表示をオン
          } else {
            console.error("displayData.fence のデータ型が不正です:", typeof this.displayData.fence);
          }
          await this.updateWildlifeAndFenceDisplay();

          alert("編集した内容を更新しました")
          
        });
        buttonContainer.appendChild(updateButton);
      }


      commentContainer.appendChild(buttonContainer);
      return commentContainer;
    },


    // 表示設定ポップアップの表示
    showDisplaySettingsPopup() {

      if (this.isDisplaySettingsPopupOpen) {
        // console.log("表示設定ポップアップはすでに表示されています");
        return; // すでに表示されている場合は何もしない
      }

      this.isDisplaySettingsPopupOpen = true; // ポップアップを開いたことを記録

      /**
       * 複数グループのチェック状態を一括切替する処理
       *
       * 指定された複数グループのチェックボックス状態を確認し、
       * すべてONの場合は全てOFFに、1つでもOFFがあれば全てONに切り替える
       *
       * @param {Array<Object>} groups - 切替対象グループ配列
       * @param {Object} groups[].data - 各チェック状態を保持するオブジェクト
       * @param {string} groups[].prefix - チェックボックスID生成用プレフィックス
       */
      const toggleMultipleGroups = (groups) => {

        // ===== 現在の状態確認 =====
        // すべてのグループ内の値が true かどうか判定
        const allChecked = groups.every(group =>
          Object.values(group.data).every(v => v)
        );

        // ===== 新しい状態決定 =====
        // すべてONならOFFに、それ以外ならONにする
        const newState = !allChecked;

        // ===== 各グループの状態更新 =====
        groups.forEach(group => {
        
          Object.keys(group.data).forEach(key => {
          
            // データ状態を更新
            group.data[key] = newState;
          
            // 関連するDOMチェックボックスも同期
            const checkbox = document.getElementById(`${group.prefix}-${key}`);
            if (checkbox) checkbox.checked = newState;
          
          });
        
        });
      
      };

      // ディープコピーで一時データを作成（ポップアップごとに独立）
      const tempDisplaySettingsPopupData = JSON.parse(JSON.stringify(this.displayData));
      const settingsContainer = document.createElement("div");
      settingsContainer.classList.add("new-settings-popup");
      // const title = document.createElement("h2");
      // title.innerHTML = "表示設定";
      // settingsContainer.appendChild(title);

      // // 獣種
      // const animalHeader = document.createElement("h3");
      // animalHeader.innerHTML = "獣種";
      // settingsContainer.appendChild(animalHeader);

      // const animalData = Object.keys(tempDisplaySettingsPopupData.animal);
      // animalData.forEach((animal) => {
      //   const checkbox = document.createElement("input");
      //   checkbox.type = "checkbox";
      //   checkbox.id = `animal-${animal}`;
      //   checkbox.checked = tempDisplaySettingsPopupData.animal[animal];

      //   // 獣種用チェックボックス処理
      //   checkbox.addEventListener("change", () => {
      //     if (animal === 'すべて') {
      //       const isChecked = checkbox.checked;
      //       animalData.forEach((a) => {
      //         tempDisplaySettingsPopupData.animal[a] = isChecked;
      //         const cb = document.getElementById(`animal-${a}`);
      //         if (cb) cb.checked = isChecked;
      //       });
      //     } else {
      //       tempDisplaySettingsPopupData.animal[animal] = checkbox.checked;
      //       const allChecked = animalData.slice(1).every((a) => tempDisplaySettingsPopupData.animal[a]);
      //       tempDisplaySettingsPopupData.animal['すべて'] = allChecked;
      //       const allCheckbox = document.getElementById('animal-すべて');
      //       if (allCheckbox) allCheckbox.checked = allChecked;
      //     }
      //   });

      //   const label = document.createElement("label");
      //   label.htmlFor = `animal-${animal}`;
      //   label.innerHTML = animal;

      //   const container = document.createElement("div");
      //   container.style.display = "flex";
      //   container.appendChild(checkbox);
      //   container.appendChild(label);
      //   settingsContainer.appendChild(container);
      // });

      // // 種別
      // const typeHeader = document.createElement("h3");
      // typeHeader.innerHTML = "種別";
      // settingsContainer.appendChild(typeHeader);
      
      /* ================================
          3カラムレイアウト作成
      ================================= */

      const createColumn = () => {
        const col = document.createElement("div");
        col.classList.add("settings-column");
        return col;
      };

      // 左カラム
      const leftColumn = createColumn();

      // 中央カラム
      const centerColumn = createColumn();

      // 右カラム
      const rightColumn = createColumn();

      // 横並びコンテナ
      const contentRow = document.createElement("div");
      contentRow.classList.add("settings-content-row");

      contentRow.appendChild(leftColumn);
      contentRow.appendChild(centerColumn);
      contentRow.appendChild(rightColumn);

      settingsContainer.appendChild(contentRow);
      
      // 種別
      const typeHeader = document.createElement("label");
      typeHeader.textContent = "種別";
      typeHeader.classList.add("settings-group-label");

      typeHeader.addEventListener("click", async () => {

        toggleMultipleGroups([
          {
            prefix: "type",
            data: tempDisplaySettingsPopupData.type
          }
        ]);

        await applyDisplayChange();

      });

      leftColumn.appendChild(typeHeader);

      const typeData = Object.keys(tempDisplaySettingsPopupData.type);
      typeData.forEach((type) => {
        // const checkbox = document.createElement("input");
        // checkbox.type = "checkbox";
        // checkbox.id = `type-${type}`;
        // checkbox.checked = tempDisplaySettingsPopupData.type[type];

        const { row, checkbox } = this.createDisplaySettingsPopupUI(
          `type-${type}`,
          type,
          tempDisplaySettingsPopupData.type[type],
          item => this.typeIcons[item],
          item => this.typeColors[item]
        );

        // 種別用チェックボックス処理
      //   checkbox.addEventListener("change", () => {
      //     if (type === 'すべて') {
      //       const isChecked = checkbox.checked;
      //       typeData.forEach((t) => {
      //         tempDisplaySettingsPopupData.type[t] = isChecked;
      //         const cb = document.getElementById(`type-${t}`);
      //         if (cb) cb.checked = isChecked;
      //       });
      //     } else {
      //       tempDisplaySettingsPopupData.type[type] = checkbox.checked;
      //       const allChecked = typeData.slice(1).every((t) => tempDisplaySettingsPopupData.type[t]);
      //       tempDisplaySettingsPopupData.type['すべて'] = allChecked;
      //       const allCheckbox = document.getElementById('type-すべて');
      //       if (allCheckbox) allCheckbox.checked = allChecked;
      //     }
      //   });

      //   const label = document.createElement("label");
      //   label.htmlFor = `type-${type}`;
      //   label.innerHTML = type;

      //   const container = document.createElement("div");
      //   container.style.display = "flex";
      //   container.appendChild(checkbox);
      //   container.appendChild(label);
      //   settingsContainer.appendChild(container);
      // });

        checkbox.addEventListener("change", async () => {

          tempDisplaySettingsPopupData.type[type] = checkbox.checked;

          await applyDisplayChange();
        });

        leftColumn.appendChild(row);
      });
      
      // 獣種
      const animalHeader = document.createElement("label");
      animalHeader.textContent = "獣種";
      animalHeader.classList.add("settings-group-label");

      animalHeader.addEventListener("click", async () => {

        toggleMultipleGroups([
          {
            prefix: "animal",
            data: tempDisplaySettingsPopupData.animal
          }
        ]);

        await applyDisplayChange();

      });

      centerColumn.appendChild(animalHeader);

      const animalData = Object.keys(tempDisplaySettingsPopupData.animal);
      const animalOtherIndex = animalData.indexOf("その他");

      animalData.forEach((animal) => {
        
        const { row, checkbox } = this.createDisplaySettingsPopupUI(
          `animal-${animal}`,
          animal,
          tempDisplaySettingsPopupData.animal[animal],
          item => this.animalIcons[item],
          null
        );

        // 獣種用チェックボックス処理
        checkbox.addEventListener("change", async () => {

            tempDisplaySettingsPopupData.animal[animal] = checkbox.checked;

            await applyDisplayChange();
        });

        centerColumn.appendChild(row);

      });

      /* ================================
          ヒートマップ
      ================================ */

      if (animalOtherIndex !== -1) {
        
        for (let i = 0; i < 2; i++) {
          const spacer = document.createElement("div");
          spacer.classList.add("settings-spacer-row");
          leftColumn.appendChild(spacer);
        }
      
        /* ----- ヒートマップタイトル ----- */
      
        const heatMapHeader = document.createElement("div");
        heatMapHeader.textContent = "ヒートマップ";
        heatMapHeader.classList.add("settings-heatmap-label");
        
        heatMapHeader.addEventListener("click", async () => {

          toggleMultipleGroups([
            {
              prefix: "heatMap",
              data: tempDisplaySettingsPopupData.heatMap
            }
          ]);

          await applyDisplayChange();

        });

        leftColumn.appendChild(heatMapHeader);
      
        /* ----- HeatMap checkbox ----- */
      
        const heatmapData = Object.keys(tempDisplaySettingsPopupData.heatMap);
      
        heatmapData.forEach((heatMap) => {
        
          const { row, checkbox } = this.createDisplaySettingsPopupUI(
            `heatMap-${heatMap}`,
            heatMap,
            tempDisplaySettingsPopupData.heatMap[heatMap],
            null,
            (item) => this.heatMapColors[item]
          );
        
          const img = row.querySelector("img");
          if (img) img.remove();
        
          checkbox.addEventListener("change", async () => {

            tempDisplaySettingsPopupData.heatMap[heatMap] = checkbox.checked;

            await applyDisplayChange();
            
          });
        
          leftColumn.appendChild(row);
        });
      }

      // 柵種
      // const fenceHeader = document.createElement("h3");
      // fenceHeader.innerHTML = "柵種";
      // settingsContainer.appendChild(fenceHeader);
      const fenceHeader = document.createElement("label");
      fenceHeader.textContent = "柵種";
      fenceHeader.classList.add("settings-group-label");

      fenceHeader.addEventListener("click", async () => {

        toggleMultipleGroups([
          {
            prefix: "fence",
            data: tempDisplaySettingsPopupData.fence
          }
        ]);

        await applyDisplayChange();

      });

      rightColumn.appendChild(fenceHeader);

      const fenceData = Object.keys(tempDisplaySettingsPopupData.fence);
      fenceData.forEach((fence) => {
        // const checkbox = document.createElement("input");
        // checkbox.type = "checkbox";
        // checkbox.id = `display-settings-fence-${fence}`;
        // checkbox.checked = tempDisplaySettingsPopupData.fence[fence];
        const { row, checkbox } = this.createDisplaySettingsPopupUI(
          `fence-${fence}`,
          fence,
          tempDisplaySettingsPopupData.fence[fence],
          item => {
              const canvas = document.createElement('canvas');
              canvas.width = 20;
              canvas.height = 20;
              const ctx = canvas.getContext('2d');
              ctx.strokeStyle = this.fenceColors[item] || '#000000';
              ctx.lineWidth = 3;
              ctx.beginPath();
              ctx.moveTo(0, 10);
              ctx.lineTo(20, 10);
              ctx.stroke();
              return canvas.toDataURL();
          },
          null
        );

        // 柵種用チェックボックス処理
        // checkbox.addEventListener("change", () => {
        checkbox.addEventListener("change", async () => {
          // if (fence === 'すべて') {
          //   const isChecked = checkbox.checked;
          //   fenceData.forEach((f) => {
          //     tempDisplaySettingsPopupData.fence[f] = isChecked;
          //     const cb = document.getElementById(`display-settings-fence-${f}`);
          //     if (cb) cb.checked = isChecked;
          //   });
          // } else {
            tempDisplaySettingsPopupData.fence[fence] = checkbox.checked;
      //       const allChecked = fenceData.slice(1).every((f) => tempDisplaySettingsPopupData.fence[f]);
      //       tempDisplaySettingsPopupData.fence['すべて'] = allChecked;
      //       const allCheckbox = document.getElementById('display-settings-fence-すべて');
      //       if (allCheckbox) allCheckbox.checked = allChecked;
      //     }
      //   });

      //   const label = document.createElement("label");
      //   label.htmlFor = `display-settings-fence-${fence}`;
      //   label.innerHTML = fence;

      //   const container = document.createElement("div");
      //   container.style.display = "flex";
      //   container.appendChild(checkbox);
      //   container.appendChild(label);
      //   settingsContainer.appendChild(container);
      // });

      // const buttonContainer = document.createElement("div");
      // buttonContainer.style.display = "flex";
      // buttonContainer.style.justifyContent = "center";
      // buttonContainer.style.gap = "10px";

      // // 一時データを反映
      // const updateButton = this.createPopupButton(
      //   "更新",
      //   "update-button",
      //   async () => {
          
      //     this.displayData = JSON.parse(JSON.stringify(tempDisplaySettingsPopupData)); // 一時データを保存
      //     this.saveDisplayDataToLocalStorage(); // 表示設定を保存
      //     await this.updateWildlifeAndFenceDisplay(); // 表示を更新
      //     // リフレッシュ
      //     location.reload();
      //     this.isDisplaySettingsPopupOpen = false; // 状態をリセット
      //     document.body.removeChild(settingsContainer);
      //   }
      // );

            await applyDisplayChange();
        });

        rightColumn.appendChild(row);
      });

      /* ================================
          閉じるボタン
      ================================ */

      if (animalOtherIndex !== -1) {
        
        for (let i = 0; i < 4; i++) {
          const spacer = document.createElement("div");
          spacer.classList.add("settings-spacer-row");
          rightColumn.appendChild(spacer);
        }
      
        const buttonContainer = document.createElement("div");
        buttonContainer.classList.add("settings-close-align");
      
        const closeButton = this.createPopupButton(
          "閉じる",
          "close-button-gray",
          () => {
            //document.body.removeChild(settingsContainer); // 一時データを破棄
            this.popupControlRoot.removeChild(settingsContainer);
            this.isDisplaySettingsPopupOpen = false; // フラグをリセット
          }
        );
        // buttonContainer.appendChild(updateButton);
        buttonContainer.appendChild(closeButton);
        // settingsContainer.appendChild(buttonContainer);
        rightColumn.appendChild(buttonContainer);
      }

      /**
       * 表示設定変更の適用処理
       *
       * ポップアップ内で変更された一時設定を本体表示設定へ反映し、
       * ローカルストレージへ保存後、地図表示を再描画する
       *
       */
      const applyDisplayChange = async () => {

        // ===== 一時設定データを本体表示設定へ反映（ディープコピー） =====
        // JSON経由でコピーすることで参照切りを行う
        this.displayData = JSON.parse(JSON.stringify(tempDisplaySettingsPopupData));
        

        // ===== ローカルストレージへ保存 =====
        this.saveDisplayDataToLocalStorage(JSON.parse(JSON.stringify(tempDisplaySettingsPopupData)));

        // ===== 地図表示の再描画 =====
        // マーカー・ポリライン・ヒートマップなどを更新
        await this.updateWildlifeAndFenceDisplay(JSON.parse(JSON.stringify(tempDisplaySettingsPopupData)));

      };

      // document.body.appendChild(settingsContainer);
      this.popupControlRoot.appendChild(settingsContainer);

      this.enablePopupDragging(settingsContainer);
    },

    backgroundLayoutSettings() {
      if (!this.map) return;

      const mapType = this.layoutData.background[this.currentSelectBackground];
      if (mapType == 'satellite' && this.currentSelectLayout.includes('ラベル表示')) {
        this.map.setMapTypeId('hybrid');
      } else {
        this.map.setMapTypeId(mapType);
      }
    },

    async layoutSettings() {
      this.labelLayoutSet = false;
      this.meshLayoutSet = false;
      this.wildlifeSanctuaryLayoutSet = false;
      this.currentSelectLayout.forEach(layout => {
        switch (layout) {
          case 'ラベル表示':
            this.labelLayoutSet = true;
            break;
          case 'メッシュ表示':
            this.meshLayoutSet = true;
            break;
          case '鳥獣保護区':
            this.wildlifeSanctuaryLayoutSet = true;
            break;
        }
      });
      this.labelsVisibility(this.labelLayoutSet);
      this.meshVisibility(this.meshLayoutSet);
      await this.wildlifeSanctuaryVisibility(this.wildlifeSanctuaryLayoutSet);
    },

    labelsVisibility(visible) {
      if (!this.map) return;
      const styles = visible
        ? [
            {
              featureType: 'all',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }]
            }
          ]
        : [
            {
              featureType: 'all',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }]
            }
          ];

      this.map.setOptions({ styles });
      if (visible && this.currentSelectBackground == '航空写真') {
        this.map.setMapTypeId('hybrid');
      }
    },
    
    meshVisibility(visible) {
      if (!this.map) return;
      const el = document.querySelector(".custom_control");
      if (el && !visible) {
        this.selectMesh = '0';
        const meshTypeBtn = document.getElementById('none_mesh');
        if (meshTypeBtn) meshTypeBtn.checked = true;
        this.removeRects();
        el.style.display = "none";
      } else if (el) {
        el.style.display = "block";
      }
    },

    async wildlifeSanctuaryVisibility(visible){
      if (!this.map || !this.wildlifeLayer) return;
      if (visible) {
        if(!this.fetchGeoJSON){
          const geoJSON = await this.fetchAndFormatGeoJSON();
          this.wildlifeLayer.addGeoJson(geoJSON);
          this.fetchGeoJSON = true;
        }
        this.wildlifeLayer.setMap(this.map);
      } else {
        this.wildlifeLayer.setMap(null);
      }
    },

    async fetchAndFormatGeoJSON() {
      try {
        var prefectureId = localStorage.getItem("regionId");
		// 2026/04/30 by R.Komatsu
		if (prefectureId == 99)	prefectureId=13;
        const response = await wildlifeDamageMapApi.fetchGeoJSON(prefectureId);
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }
        
        // 
        const wildlifeSanctuaryData = response.data[0].geojson.features;
        if (!wildlifeSanctuaryData || !Array.isArray(wildlifeSanctuaryData)) {
          console.error("期待するデータ形式ではありません:", wildlifeSanctuaryData);
          return [];
        }

        const geoJSON = 
        {
          'type': response.data[0].geojson.type,
          'features': wildlifeSanctuaryData,
        };
        return geoJSON;
      } catch (error){
        console.error("鳥獣保護区一覧（都道府県）の取得に失敗しました:", error);
        return [];
      }
    },

    // レイヤー設定ポップアップの表示
    showLayoutSettingsPopup() {

      if (this.isLayoutSettingsPopupOpen) {
        // console.log("レイヤー設定ポップアップはすでに表示されています");
        return; // すでに表示されている場合は何もしない
      }

      this.isLayoutSettingsPopupOpen = true; // ポップアップを開いたことを記録

      // ディープコピーで一時データを作成（ポップアップごとに独立）
      const tempLayoutSettingsPopupData = JSON.parse(JSON.stringify(this.layoutData));
      const settingsContainer = document.createElement("div");
      settingsContainer.classList.add("layout-settings-popup");

      const columnsContainer = document.createElement("div");
      columnsContainer.style.display = "flex";
      columnsContainer.style.justifyContent = "space-between";
      columnsContainer.style.gap = "20px";
      columnsContainer.style.padding = "0px";

      // 背景表示
      const leftColumn = document.createElement("div");
      leftColumn.style.flex = "1";

      const backgroundHeader = document.createElement("h3");
      backgroundHeader.innerHTML = "背景表示";
      backgroundHeader.style.paddingLeft = "20px";
      leftColumn.appendChild(backgroundHeader);

      const backgroundData = Object.keys(tempLayoutSettingsPopupData.background);
      tempLayoutSettingsPopupData.background = this.currentSelectBackground;

      backgroundData.forEach((background) => {
        const radio = document.createElement("input");
        radio.type = "radio";
        radio.id = `background-${background}`;
        radio.name = "background-group"
        radio.value = background;
        radio.style.transform = "scale(1.3)";

        if (tempLayoutSettingsPopupData.background === background) {
          radio.checked = true;
        }

        // 背景表示用チェックボックス処理
        radio.addEventListener("change", () => {
          if (radio.checked) {
            tempLayoutSettingsPopupData.background = background;
            this.currentSelectBackground = background
            this.backgroundLayoutSettings();
          }
        });

        const label = document.createElement("label");
        label.htmlFor = `background-${background}`;
        label.innerHTML = background;
        label.style.paddingLeft = "12px";

        const container = document.createElement("div");
        container.style.display = "flex";
        container.style.paddingBottom = "20px"
        container.style.fontSize = "18px";
        container.style.whiteSpace = "nowrap";
        container.appendChild(radio);
        container.appendChild(label);
        leftColumn.appendChild(container);
      });

      //　レイヤー表示
      const middleColumn = document.createElement("div");
      middleColumn.style.flex = "1";

      const layoutHeader = document.createElement("h3");
      layoutHeader.innerHTML = "レイヤー表示";
      layoutHeader.style.paddingLeft = "30px";
      layoutHeader.style.whiteSpace = "nowrap";
      middleColumn.appendChild(layoutHeader);

      const layoutData = Object.values(tempLayoutSettingsPopupData.layout);
      tempLayoutSettingsPopupData.layout = this.currentSelectLayout;

      layoutData.forEach((layout) => {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = `layout-${layout}`;
        checkbox.className = "layout-checkbox";
        checkbox.checked = tempLayoutSettingsPopupData.layout.includes(layout);
        checkbox.style.transform = "scale(1.3)";

        // レイヤー表示用チェックボックス処理
        checkbox.addEventListener("change", () => { 
          if (checkbox.checked) {
            if (!tempLayoutSettingsPopupData.layout.includes(layout)) {
              tempLayoutSettingsPopupData.layout.push(layout);
              this.currentSelectLayout.push(layout);
            }
          } else {
            const index = tempLayoutSettingsPopupData.layout.indexOf(layout);
            if (index > -1) {
              tempLayoutSettingsPopupData.layout.splice(index, 1);
              this.currentSelectLayout.splice(index, 1);
            }
          }
          this.layoutSettings();
        });

        const label = document.createElement("label");
        label.htmlFor = `layout-${layout}`;
        label.innerHTML = layout;
        label.style.paddingLeft = "10px";

        const container = document.createElement("div");
        container.style.display = "flex";
        container.style.paddingLeft = "10px"
        container.style.paddingBottom = "20px"
        container.style.fontSize = "18px";
        container.style.whiteSpace = "nowrap";

        container.appendChild(checkbox);
        container.appendChild(label);
        middleColumn.appendChild(container);
      });

      const rightColumn = document.createElement("div");
      rightColumn.style.flex = "1";

      const buttonContainer = document.createElement("div");
      buttonContainer.style.display = "flex";
      buttonContainer.style.justifyContent = "center";
      buttonContainer.style.gap = "10px";

      const closeButton = this.createPopupButton(
        "閉じる",
        "layout-close-button",
        () => {
          // document.body.removeChild(settingsContainer); // 一時データを破棄
          this.popupControlRoot.removeChild(settingsContainer);
          this.isLayoutSettingsPopupOpen = false; // フラグをリセット
          this.saveLayoutDataToLocalStorage();
        }
      );
      
      buttonContainer.appendChild(closeButton);

      rightColumn.appendChild(buttonContainer);

      columnsContainer.appendChild(leftColumn);
      columnsContainer.appendChild(middleColumn);
      columnsContainer.appendChild(rightColumn);

      settingsContainer.appendChild(columnsContainer);

      // document.body.appendChild(settingsContainer);
      this.popupControlRoot.appendChild(settingsContainer);
      this.enablePopupDragging(settingsContainer);
    },
    // ポップアップを閉じる
    closeChildPopups() {
        // すべてのポップアップを取得
        const popups = document.querySelectorAll('.comment-popup, .new-settings-popup, .draggable-popup, .layout-settings-popup');
        popups.forEach(popup => {
            if (popup.parentNode) {
                // 親ノードから削除
                popup.parentNode.removeChild(popup);
            } else {
                console.warn("ポップアップの親ノードが見つかりません:", popup);
            }
        });

        // 各状態をリセット
        this.isFenceEditPopupOpen = false;
        this.isDisplaySettingsPopupOpen = false;
        this.isLayoutSettingsPopupOpen = false;
        // console.log("すべてのポップアップが閉じられました");
    },

    //編集開始処理
    startEditing(map) {
      this.addingMarkers = true;
      const newPolyline = new google.maps.Polyline({
        path: [],
        strokeColor: this.fenceColors[this.fenceType],
        strokeOpacity: 1.0,
        strokeWeight: 3,
      });
      newPolyline.setMap(map);
      this.polylines.push(newPolyline);
      this.currentPolylinePath = [];
      newPolyline.addListener("dblclick", () => {
        this.showFencePopup("new");
      });
    },

    //編集終了処理
    stopEditing() {
      this.addingMarkers = false;
      if (this.polylines.length > 0) {
        this.polylines[this.polylines.length - 1].setPath(this.currentPolylinePath);
      }
      this.removeMarkers(); // マーカーを削除
      this.showFencePopup("new"); // 子画面の表示
    },

    removeWildlifeMarkers() {
      this.wildlifeMarkersData.forEach((overlay) => {
        if (overlay instanceof google.maps.OverlayView) {
          // カスタムオーバーレイの場合、地図から削除
          //overlay.setMap(null);
        // } else if (overlay instanceof google.maps.Marker) {
        }
        if (overlay instanceof google.maps.Marker) {
          // 通常のマーカーの場合
          overlay.setMap(null);
        }
      });

      this.wildlifeMarkersData = []; // 新しいマーカーをリセット
      toRaw(this.wildlifeMarkerClusterer).clearMarkers();
    },

    removePolylines() {
      this.polylines.forEach((polyline) => {
        toRaw(polyline).setMap(null); // 地図からポリラインを削除
        polyline.setVisible(false); // 見た目も確実に非表示にする
      });
      this.polylines = []; // 配列をクリア
    },


    async changeCategory(category) {
      this.currentCategory = category;
      await this.updateWildlifeAndFenceDisplay(); // マーカーを更新
    },

    createPopupButton(text, className, onClick ) {
      const button = document.createElement("button");
      button.innerHTML = text;
      button.className = className;
      button.addEventListener("click", onClick);
      return button;
    },

    async showFencePopup(mode, id = null) {

      //console.log("モード:", mode);
      // console.log("対象ID:", id);

      this.isFenceEditPopupOpen = true; // 子画面が表示された状態にする
      const commentContainer = await this.buildFencePopupContent(mode, id);
      // document.body.appendChild(commentContainer);
      this.popupDetailControlRoot.appendChild(commentContainer);
      this.enablePopupDragging(commentContainer);
    },
    showRegisterPopup() {
      const registerContainer = this.buildRegisterPopupContent();
      document.body.appendChild(registerContainer);
    },

    // 最後に追加されたポリラインを削除する
    removeLastPolyline() {
      if (this.polylines.length > 0) {
        const lastPolyline = this.polylines[this.polylines.length - 1];

        if (lastPolyline) {
          // リスナーを解除
          google.maps.event.clearInstanceListeners(lastPolyline);

          // まず描画を非表示に
          lastPolyline.setVisible(false);

          // 地図から削除
          lastPolyline.setMap(null);

          // 配列から削除
          this.polylines.pop();
        }
        // 地図全体をリセット
        this.resetMap();
      } else {
        console.warn("削除対象のポリラインが存在しません");
      }
    },


    updatePolylineColor(details) {
      const polylineToUpdate = this.polylines.find((polyline) =>
        polyline.fenceDetails.id === details.id // IDで検索
      );

      if (polylineToUpdate) {
        polylineToUpdate.setOptions({
          strokeColor: this.fenceColors[details.type] || "#000000", // 正しい色を設定
        });
        polylineToUpdate.fenceDetails.type = details.type; // 柵種を更新
      } else {
        console.warn("該当するポリラインが見つかりませんでした:", details.id);
      }
    },
    
    createFenceDetails(fenceData, index) {
      return {
        ...fenceData.details || {}, // デフォルト値を空オブジェクトにする
        id: fenceData.id, // IDを確実に数値として設定
        type: fenceData.type || "不明", // 柵種がなければデフォルト値
        polylineId: index,
        path: fenceData.path || [], // 座標がなければ空配列
      };
    },

    // 共通バリデーション関数
    validateField(inputs, key, value, required, label, maxLength = null) {
      if (required && (!value || value.trim() === "")) {
        return `${label}は必須です`;
      }

      // 必須チェックをクリアした場合のみ以下を実行
      // 最大文字数チェック
      if (maxLength !== null && value.length > maxLength) {
        return `${label}は最大${maxLength}文字以内で入力してください`;
      }

      // 数値チェック
      if (key === "length") {
        // 半角英数字チェック
        const isNumeric = /^[0-9]+(\.[0-9]{1,2})?$/.test(value); // 小数点以下2桁まで許容
        if (!isNumeric) {
          return `${label}は半角英数字で小数点第2位まで入力してください`;
        }
      }

      // installDate の日付チェック（必須チェック後に実行）
      if (key === "installDate" && value.trim() !== "") {
        // 厳密な日付フォーマットチェック (YYYY-MM-DD)
        const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (!isValidFormat) {
          return `${label}はYYYY-MM-DD形式で入力してください`;
        }

        // 日付の有効性チェック
        const [year, month, day] = value.split("-").map(Number);
        const date = new Date(value);
        const isValidDate =
          date.getFullYear() === year &&
          date.getMonth() + 1 === month &&
          date.getDate() === day;

        if (!isValidDate) {
          return `${label}には有効な日付を入力してください`;
        }
      }

      // removeDate の日付チェック（値があれば実行）
      if (key === "removeDate" && value.trim() !== "") {
        // 厳密な日付フォーマットチェック (YYYY-MM-DD)
        const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (!isValidFormat) {
          return `${label}はYYYY-MM-DD形式で入力してください`;
        }

        // 日付の有効性チェック
        const [year, month, day] = value.split("-").map(Number);
        const date = new Date(value);
        const isValidDate =
          date.getFullYear() === year &&
          date.getMonth() + 1 === month &&
          date.getDate() === day;

        if (!isValidDate) {
          return `${label}には有効な日付を入力してください`;
        }

        // installDate が入力されている場合に順序チェック
        if (inputs["installDate"] && inputs["installDate"].value) {
          const installDate = new Date(inputs["installDate"].value);
          const removeDate = new Date(value);
          if (installDate > removeDate) {
            return `${label}は設置日より後の日付を入力してください`;
          }
        }
      }

      return ""; // エラーがない場合は空文字を返す
    },

    // エラー表示更新関数
    updateErrorDisplay(errorElement, inputElement, errorMessage) {
      if (errorMessage) {
        errorElement.innerHTML = errorMessage; // エラーメッセージを設定
        errorElement.style.display = "block"; // 表示
        inputElement.classList.add("input-error"); // エラー時のスタイルを適用
      } else {
        errorElement.innerHTML = ""; // エラーメッセージをクリア
        errorElement.style.display = "none"; // 非表示
        inputElement.classList.remove("input-error"); // エラー時のスタイルを解除
      }
    },

    // カスタムコントロール
    createMeshButton(controlDiv) {
      const controlUI = document.createElement('div');
      controlUI.className = 'custom_control';
      if (this.meshLayoutSet) {
        controlUI.style.display = 'block'; 
      } else {
        controlUI.style.display = 'none'; 
      }
      controlDiv.appendChild(controlUI);
      let meshText = '';
        meshText += `<input type="radio" name="mesh_code" id="none_mesh" value="0" ${this.selectMesh === '0' ? 'checked' : ''}><label for="none_mesh" class="switch-on">表示しない</label>`;
        //meshText += `<input type="radio" name="mesh_code" id="first_mesh" value="1" ${this.selectMesh === '1' ? 'checked' : ''}><label for="first_mesh" class="switch-off">1次メッシュ</label>`;
        //meshText += `<input type="radio" name="mesh_code" id="second_mesh" value="2" ${this.selectMesh === '2' ? 'checked' : ''}><label for="second_mesh" class="switch-off">2次メッシュ</label>`;
        //meshText += `<input type="radio" name="mesh_code" id="fivetimes_mesh" value="4" ${this.selectMesh === '4' ? 'checked' : ''}><label for="fivetimes_mesh" class="switch-off">5倍メッシュ</label>`;
        meshText += `<input type="radio" name="mesh_code" id="third_mesh" value="3" ${this.selectMesh === '3' ? 'checked' : ''}><label for="third_mesh" class="switch-off">3次メッシュ</label>`;

        const controlText = document.createElement('div');
        controlText.className = 'mesh_select';
        controlText.innerHTML = meshText;
        controlUI.appendChild(controlText);

        controlUI.addEventListener('click', (event) => {
          if (event.target.name === 'mesh_code') {
            //if (document.display_capture_result?.json_data?.value === '') return;

            this.selectMesh = event.target.value;

            // 検索結果が設定されている場合、入力に応じて地図描画変更
            this.displayMesh();
          }
        });
    },
    // Mesh地図描画
    async displayMesh() {
      // zoom設定
      var currentZoom = this.map.getZoom();
      switch(this.selectMesh) {
        //case '1':
        //    if (currentZoom < 6) {
        //      currentZoom = 8;
        //    }
        //    break;
        //case '2':
        //    if (currentZoom < 10) {
        //      currentZoom = 11;
        //    }
        //    break;
        //case '4':
        //    if (currentZoom < 11) {
        //      currentZoom = 12;
        //    }
        //    break;
        case '3':
            if (currentZoom < 13) {
              this.map.setZoom(14);
            }
            break;
        default:
            break;
      }
      this.removeRects();
      this.drawMesh();
    },
    drawMesh(){
      if (!this.meshLayoutSet) {
          this.selectMesh = '0';
          const meshTypeBtn = document.getElementById('none_mesh');
          if (meshTypeBtn) meshTypeBtn.checked = true;
          return;
      }
      const zoom = this.map.getZoom();
      console.log('zoom=', zoom);
      // メッシュ種類調整
      //if (this.selectMesh == '1' && zoom < 6) {
      //  this.removeRects();
      //  this.selectMesh = '0';
      //  const meshTypeBtn = document.getElementById('none_mesh');
      //  if (meshTypeBtn) meshTypeBtn.checked = true;
      //  await this.resetMap();
      //} else if (this.selectMesh == '2' && zoom < 10) {
      //  this.removeRects();
      //  this.selectMesh = '1';
      //  const meshTypeBtn = document.getElementById('first_mesh');
      //  if (meshTypeBtn) meshTypeBtn.checked = true;
      //  await this.resetMap();
      //} else if (this.selectMesh == '4' && zoom < 11) {
      //  this.removeRects();
      //  this.selectMesh = '2';
      //  const meshTypeBtn = document.getElementById('second_mesh');
      //  if (meshTypeBtn) meshTypeBtn.checked = true;
      //  await this.resetMap();
      //}

      if (this.selectMesh == '3' && zoom < 13) {
        this.removeRects();
        this.selectMesh = '0';
        const meshTypeBtn = document.getElementById('none_mesh');
        if (meshTypeBtn) meshTypeBtn.checked = true;
      }

      const bounds = this.map.getBounds();
      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();
      const mesh1 = this.latlngToMeshcode(sw);
      const mesh2 = this.latlngToMeshcode(ne);
      const mesh3 = this.latlngToMeshcode(new google.maps.LatLng(sw.lat(), ne.lng()));
      const mesh4 = this.latlngToMeshcode(new google.maps.LatLng(ne.lat(), sw.lng()));
      switch (this.selectMesh) {
        //case '1': // 1次メッシュ
        //  this.draw1stMesh(mesh1, mesh2);
        //  break;
        //case '2': // 2次メッシュ
        //  this.draw2ndMesh(mesh1, mesh2);
        //  break;
        case '3': // 3次メッシュ
          this.draw3rdMesh(mesh1, mesh2, mesh3, mesh4);
          break;
        //case '4': // 5倍メッシュ
        //  this.draw5timesMesh(mesh1, mesh2);
        //  break;
        default:
          this.drawLatLngLines(); // 赤青線
          break;
      }
    },
    // ---------------------
    // 1次メッシュ
    draw1stMesh(mesh1, mesh2) {
      const y11 = parseInt(mesh1.substring(0, 2));
      const x11 = parseInt(mesh1.substring(2, 4));
      const y12 = parseInt(mesh2.substring(0, 2));
      const x12 = parseInt(mesh2.substring(2, 4));

      for (let i = y11; i <= y12; i++) {
        for (let j = x11; j <= x12; j++) {
          const mesh = i.toString() + j.toString();
          this.createRectByMesh(mesh);
        }
      }
    },
    // ---------------------
    // 2次メッシュ
    draw2ndMesh(mesh1, mesh2) {
      const y11 = parseInt(mesh1.substring(0, 2));
      const x11 = parseInt(mesh1.substring(2, 4));
      const y12 = parseInt(mesh2.substring(0, 2));
      const x12 = parseInt(mesh2.substring(2, 4));

      for (let i = y11; i <= y12; i++) {
        for (let j = x11; j <= x12; j++) {
          for (let k = 0; k < 8; k++) {
            for (let l = 0; l < 8; l++) {
              const mesh = i.toString() + j.toString() + k.toString() + l.toString();
              this.createRectByMesh(mesh);
            }
          }
        }
      }
    },
    // ---------------------
    // 3次メッシュ
    draw3rdMesh(mesh1, mesh2, mesh3, mesh4) {
      const y11 = parseInt(mesh1.substring(0, 6));
      const y12 = parseInt(mesh2.substring(0, 6));
      const y13 = parseInt(mesh3.substring(0, 6));
      const y14 = parseInt(mesh4.substring(0, 6));

      for (let i = y11; i <= y13; i++) {
        for (let k = 0; k < 10; k++) {
          for (let l = 0; l < 10; l++) {
            const mesh = i.toString() + k.toString() + l.toString();
            this.createRectByMesh(mesh);
          }
        }
      }
      if (y11 < y14) {
        for (let j = y14; j <= y12; j++) {
          for (let k = 0; k < 10; k++) {
            for (let l = 0; l < 10; l++) {
              const mesh = j.toString() + k.toString() + l.toString();
              this.createRectByMesh(mesh);
            }
          }
        }
      }
    },
    // ---------------------
    // 5倍メッシュ
    draw5timesMesh(mesh1, mesh2) {
      const y11 = parseInt(mesh1.substring(0, 2));
      const x11 = parseInt(mesh1.substring(2, 4));
      const y12 = parseInt(mesh2.substring(0, 2));
      const x12 = parseInt(mesh2.substring(2, 4));

      for (let i = y11; i <= y12; i++) {
        for (let j = x11; j <= x12; j++) {
          for (let k = 0; k < 8; k++) {
            for (let l = 0; l < 8; l++) {
              for (let m = 1; m <= 4; m++) {
                const mesh = i.toString() + j.toString() + k.toString() + l.toString() + m.toString();
                this.createRectByMesh(mesh);
              }
            }
          }
        }
      }
    },
    // ---------------------
    // 赤青経緯線
    drawLatLngLines() {
      // 緯度線 (-85～85)
      for (let i = -85; i <= 85; i++) {
        let color = "#aaaaaa";
        let opa = 0.3;
        if (i % 5 === 0) opa = 0.6, color = i % 10 === 0 ? "#0000ff" : "#A9A9A9";
        if (i === 0) color = "#ff0000", opa = 0.8;

        const line = [{ lat: i, lng: -180 }, { lat: i, lng: 0 }, { lat: i, lng: 179.999999 }];
        new google.maps.Polyline({ path: line, strokeColor: color, strokeOpacity: opa, strokeWeight: 1 }).setMap(this.map);
      }

      // 経度線 (-180～180)
      for (let i = -180; i <= 180; i++) {
        let color = "#aaaaaa";
        let opa = 0.3;
        if (i % 5 === 0) opa = 0.6, color = i % 10 === 0 ? "#0000ff" : "#A9A9A9";
        if (i % 180 === 0) color = "#ff0000", opa = 0.8;

        const line = [{ lat: 85, lng: i }, { lat: 0, lng: i }, { lat: -85, lng: i }];
        new google.maps.Polyline({ path: line, strokeColor: color, strokeOpacity: opa, strokeWeight: 1 }).setMap(this.map);
      }
    },
    // メッシュセルの削除
    removeRects() {
      for (let i = 0; i < this.rects.length; i++) {
        toRaw(this.rects[i]).setMap(null);
        this.rects[i].setMap(null);
      }
      this.rects = [];
      for (let i = 0; i < this.labels.length; i++) {
        this.labels[i].setMap(null);
      }
      this.labels = [];
    },
    // 緯度経度から3次メッシュコードを算出
    latlngToMeshcode(latlng) {
      const lat = latlng.lat();
      const lng = latlng.lng();

      const y1 = Math.floor(lat * 1.5);
      const x1 = Math.floor(lng) - 100;

      const lat1_0 = y1 / 1.5;
      const lng1_0 = x1 + 100;

      const y2 = Math.floor((lat - lat1_0) * 1.5 * 80);
      const x2 = Math.floor((lng - lng1_0) * 80);

      const m1 = y1.toString() + x1.toString();
      const m2 = Math.floor(y2 / 10).toString() + Math.floor(x2 / 10).toString();
      const m3 = (y2 % 10).toString() + (x2 % 10).toString();

      return `${m1}${m2}${m3}`;
    },
    // メッシュセルの描画
    createRectByMesh(mesh) {
      const exists = this.rects.some(r => r._mesh === mesh);
      if (exists) {
        return;
      }

      let totalLabel = "";
      let fillColor = "#ff0000";
      let fillOpacity = 0.05;

      let bounds = this.meshcodeToLatLngBounds(mesh);

      let rect = new google.maps.Rectangle({
        bounds,
        map: this.map,
        strokeColor: "#ff0000",
        strokeWeight: 1,
        fillColor: fillColor,
        fillOpacity: fillOpacity,
        clickable: false, 
      });
      rect._mesh = mesh;
      this.rects.push(rect);

      let MeshLabelOverlay = createMeshLabelOverlay();

      let label = new MeshLabelOverlay({
        map: this.map,
        position: bounds.getCenter(),
        content: totalLabel + mesh,
      });

      label._mesh = mesh;
      this.labels.push(label);
    },
    // メッシュコードから緯度経度を算出
    meshcodeToLatLngBounds(meshcode) {
      let south, west, north, east;
      const mc = meshcode.toString().replace(/-/g, '');
      const mcl = mc.length;

      if (mcl === 4) {
        // 1次メッシュ
        const south_sec = parseInt(mc.substring(0, 2)) * (60 * 40);
        south = south_sec / 3600;
        west = parseInt(mc.substring(2, 4)) + 100;
        north = (south_sec + (60 * 40)) / 3600;
        east = west + 1;
      } else {
        let south_sec =
          parseInt(mc.substring(0, 2)) * (60 * 40) +
          parseInt(mc.substring(4, 5)) * (60 * 5);
        let west_sec =
          (parseInt(mc.substring(2, 4)) + 100) * 3600 +
          parseInt(mc.substring(5, 6)) * (60 * 7.5);

        if (mcl === 6) {
          // 2次メッシュ
          var north_sec = south_sec + (60 * 5);
          var east_sec = west_sec + (60 * 7.5);
        } else if (mcl === 7) {
          // 5倍メッシュ（2bit）
          const fivetimes = parseInt(mc.substring(6, 7)) - 1;
          const binary = ('00' + fivetimes.toString(2)).slice(-2);
          south_sec += parseInt(binary.charAt(0)) * (30 * 5);
          west_sec += parseInt(binary.charAt(1)) * (45 * 5);
          var north_sec = south_sec + (30 * 5);
          var east_sec = west_sec + (45 * 5);
        } else {
          // 3次メッシュ（8桁）
          south_sec += parseInt(mc.substring(6, 7)) * 30;
          west_sec += parseInt(mc.substring(7, 8)) * 45;
          var north_sec = south_sec + 30;
          var east_sec = west_sec + 45;
        }

        south = south_sec / 3600;
        west = west_sec / 3600;
        north = north_sec / 3600;
        east = east_sec / 3600;
      }

      return new google.maps.LatLngBounds(
        new google.maps.LatLng(south, west),
        new google.maps.LatLng(north, east)
      );
    }
  },
  //ページ離脱時の処理
  beforeRouteLeave(to, from, next) {
    // ローカルストレージに保存された表示設定を削除
    const storageKey = "displaySettings";
    if (localStorage.getItem(storageKey)) {
      localStorage.removeItem(storageKey);
      console.log(`${storageKey} をローカルストレージから削除しました`);
    }
    // ページ遷移直前に子画面を閉じる
    this.closeChildPopups();
    next(); // 遷移を許可
  },

};
</script>

<style scoped>

/* 設定ポップアップ本体 */
:deep(.new-settings-popup) {
  position: absolute; /* 画面上に絶対配置 */
  top: 50%; /* 縦中央 */
  left: 50%; /* 横中央 */
  transform: translate(-50%, -50%); /* 中央補正 */
  background-color: #ffffff; /* 背景色 */
  border: 1px solid #ccc; /* 枠線 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* 影 */
  padding: 20px; /* 内側余白 */
  z-index: 1000; /* 前面表示 */
  width: 500px;
  max-height: 80vh; /* 最大高さ（画面高さの80%） */
  overflow-y: auto; /* 縦スクロール有効 */
  pointer-events: auto; /* クリック操作を有効にする */
  white-space: nowrap;
  user-select: none;
}

/* 柵編集/新しい柵の追加メニュー ボタンのスタイル */
:deep(.wildlife-damage-map .comment-popup) {
  height: auto;
}
:deep(.wildlife-damage-map .comment-popup .delete-button) {
  background-color: #46BDC6;
}
:deep(.wildlife-damage-map .comment-popup .update-button), 
:deep(.wildlife-damage-map .register-button) {
  background-color: #EA4335;
}

/* 各設定行（チェックボックス + アイコン + ラベル） */
:deep(.settings-item-row) {
  display: grid; /* グリッドレイアウト */
  grid-template-columns: 22px 22px auto; /* 3カラム構成 */
  align-items: center; /* 縦中央揃え */
  column-gap: 6px; /* 列間の余白 */
}

/* アイコンの外枠（丸型背景用） */
:deep(.settings-icon-container) {
  width: 18px;
  height: 18px;
  border-radius: 50%; /* 円形 */
  overflow: hidden; /* はみ出し非表示 */
  display: flex;
  justify-content: center; /* 横中央 */
  align-items: center; /* 縦中央 */
}

/* アイコン画像サイズ */
:deep(.settings-icon-img) {
  width: 17px;
  height: 17px;
}

/* ラベル文字スタイル */
:deep(.settings-label-text) {
  font-size: 15px;
  font-family: "Noto Sans JP", "sans-serif";
}

/* 3カラム横並びレイアウト（獣種・種別・柵種など） */
:deep(.settings-content-row) {
  display: flex;
  gap: 40px; /* 各カラム間の間隔 */
}

/* 各カラム縦並び */
:deep(.settings-column) {
  display: flex;
  flex-direction: column;
  gap: 8px; /* 行間 */
}

/* 空行スペース（高さ調整用） */
:deep(.settings-spacer-row) {
  height: 21px;
}

/* 閉じるボタン位置調整 */
:deep(.settings-close-align) {
  display: flex;
  align-items: flex-end; /* 下揃え */
  padding-left: 28px;
}

/* グループタイトル（例：獣種・種別など） */
:deep(.settings-group-label) {
  cursor: pointer; /* クリック可能 */
  font-weight: 700; /* 太字 */
  display: block;
  padding-left: 28px;
  margin: 0;
  margin-bottom: 6px;
  color: #212121;
  font-family: "Noto Sans JP", "sans-serif";
  font-size: 16px;
}

/* マップ上に重ねるためのルートコンテナ */
:deep(.map-popup-root) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  inset: 0;
  pointer-events: none; /* 背景マップ操作を妨げない */
  overflow: visible; /* はみ出し表示許可 */
}

/* ヒートマップラベル用スタイル */
:deep(.settings-heatmap-label) {
  cursor: pointer; /* クリック可能 */
  padding-left: 15px;
  font-weight: 700; /* 太字 */
  display: block;
  color: #212121;
  height: 21px;
  font-size: 16px;
  font-family: "Noto Sans JP", "sans-serif";
}

:deep(.custom_control) {
    padding: 8px;
}

:deep(.mesh_select input),
:deep(.display_select input) {
    display: none;
}
:deep(.mesh_select label) {
    display: block;
    float: left;
    cursor: pointer;
    width: 68px;
    margin: 0;
    padding: 8px;
    background: #bdc3c7;
    color: #869198;
    font-size: 12px;
    text-align: center;
    line-height: 1;
    transition: .2s;
}
:deep(.mesh_select label:first-of-type),
:deep(.display_select label:first-of-type) {
    border-radius: 3px 0 0 3px;
}
:deep(.mesh_select label:last-of-type),
:deep(.display_select label:last-of-type) {
    border-radius: 0 3px 3px 0;
}
:deep(.mesh_select input[type="radio"]:checked + .switch-on) {
    background-color: #4285F4;
    color: #fff;
}
:deep(.mesh_select input[type="radio"]:checked + .switch-off) {
    background-color: #4285F4;
    color: #fff;
}
:deep(.display_select input[type="radio"]:checked + .switch-on) {
    background-color: #D86B63;
    color: #fff;
}
:deep(.display_select input[type="radio"]:checked + .switch-off) {
    background-color: #D86B63;
    color: #fff;
}

:deep(.mesh-label) {
  text-align: center;
  font-size: 10pt;
  color: #ff0000;
  width: 50px;
  font-weight: bold;
}

:deep(.layout-settings-popup){
  position: absolute;
  pointer-events: auto; /* クリック操作を有効にする */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fef2cd !important;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  text-align: left;
  max-height: 80vh; /* 最大高さを画面の80%に設定 */
  overflow-y: auto; /* 縦スクロール */
  width: 450px; /* 幅を固定 */
  height: 240px; /* 高さを固定 */
  overflow: auto; /* 内容があふれた場合はスクロール */
  resize: none; /* リサイズを禁止 */
}

:deep(.layout-settings-popup input[type="radio"]) {
  appearance: none;
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  border: 1px solid #333;
  border-radius: 50%;
  background: white;
  position: relative;
  top: 5px;
}

:deep(.layout-settings-popup input[type="radio"]:checked) {
  background: black;
  border-color: black;
}

:deep(.layout-settings-popup input[type="radio"]:checked::after) {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  background: black;
  border-radius: 50%;
}

:deep(.layout-checkbox) {
  margin-bottom: 0px;
}

/* 閉じるボタンのスタイル */
:deep(.close-button-gray) {
  background-color: #A6A6A6; 
  border-radius:10px; 
}

/* 「レイヤー設定」ボタン */
:deep(.layout-settings-button) {
  background-color: #fbbc04; /* 黄色 */
  color: white;
}
:deep(.layout-settings-button:hover) {
  background-color: #e6ac01; /* ホバー時の黄色 */
  color: white;
}
:deep(.layout-close-button) {
  width: 120px;
  height: 65px;
  background-color: #a6a6a6;
  margin-top: 155px;
  font-size: large;
  border-radius: 12px;
}
:deep(.draggable-popup) {
  font-size: 16px;
}

</style>
